// Catálogo de viajes — single source of truth (sincronizado con backend VALID_TRIP_SLUGS)
// Schema:
//   slug, external_id, booking_url, name, short_name, season,
//   dates, dates_short, duration, ski_days, regimen, room_distribution,
//   price_from, price_label, family_basis, image, gallery,
//   hotel: { name, highlights },
//   resort: { name, highlights },
//   intro, pain_hook,
//   prices: [{ label, amount, note?, free? }],
//   includes: [string],
//   supplements: [{ label, amount, note? }],
//   notes: [string],
//   seo_title, seo_description
//
// Los viajes marcados con "extended: true" tienen datos completos.
// Los demás se irán enriqueciendo a medida que se pase la URL de origen.

export const TRIPS = [
  {
    slug: "masella-inmaculada",
    extended: true,
    external_id: 263,
    booking_url: "https://www.clubamistad.com/viajes-esqui/presupuesto/263",
    pdf_url: "/dossiers/masella-inmaculada.pdf",
    name: "Masella, Puente de la Inmaculada",
    short_name: "Masella",
    season: "Puente de la Inmaculada",
    dates: "Del viernes 4 al martes 8 de diciembre de 2026",
    dates_short: "4 – 8 dic 2026",
    duration: "5 días / 4 noches",
    ski_days: 4,
    regimen: "Media pensión — desayuno y cena buffet",
    room_distribution: "Habitaciones de 2 a 6 personas",
    price_from: 298,
    price_label: "Desde 298 €/persona",
    family_basis: "2 adultos + 2 niños",
    hero_image: "/trips/masella-inmaculada/hero.jpg",
    image: "/trips/masella-inmaculada/01.jpg",
    gallery: [
      "/trips/masella-inmaculada/01.jpg",
      "/trips/masella-inmaculada/02.jpg",
      "/trips/masella-inmaculada/03.jpg",
      "/trips/masella-inmaculada/04.jpg",
      "/trips/masella-inmaculada/05.jpg",
      "/trips/masella-inmaculada/06.jpg",
    ],
    hotel: {
      name: "Alp Hotel Masella 3★",
      subtitle: "A 300 m de la base · piscina climatizada · cine y sala de juegos",
      address: "Avenida de Josep Maria Bosch Aymerich, s/n · 17538 Alp · Girona",
      phone: "972 144 201",
      highlights: [
        "Los niños bajan a desayunar y salen a la pista literalmente en la puerta del hotel.",
        "Comidas buffet — cada uno elige, sin dramas ni negociaciones a la hora del plato.",
        "Piscina interior climatizada, gimnasio, cine, sala de juegos y hasta discoteca para la sobremesa.",
        "Habitaciones familiares para 2 a 6 personas, pensadas para no ir apretados con los pequeños.",
      ],
      extra_info: {
        description:
          "Este hotel está situado frente a las mismas pistas de Masella, a escasos metros de la zona de debutantes y remontes. Ideal para familias, tanto por la cercanía a pistas como por las actividades que se organizan tarde y noche para todas las edades. Todas las comidas son estilo buffet y cuenta con piscina interior climatizada, gimnasio y zonas de ocio (cine, sala de juegos y discoteca). La mayor virtud de este hotel es sin duda su situación, en la misma base de la estación. Apenas 300 metros separan su puerta principal de la base de la estación, su zona de debutantes y los remontes que dan acceso a las cotas altas. Las habitaciones son sencillas y funcionales. Las habitaciones estándar cuentan con dos camas individuales y un espacio donde se incorporan las supletorias, ya sea una con cama inferior o dos, con la litera correspondiente. Aunque estas habitaciones son ideales para alojar a familias de 3 o 4 miembros, el espacio libre una vez desplegadas las camas supletorias es muy limitado, así como su espacio de armarios. Para familias de 5 o más miembros el hotel cuenta con un número limitado de habitaciones familiares con dos habitáculos y un único cuarto de baño. Todas sus comidas se llevan a cabo con buffet en su amplio restaurante con vistas a la montaña. Cuenta además con un amplio salón con bar, futbolines y villares. En esta zona se lleva a cabo normalmente la animación del hotel durante las noches de la temporada de invierno.",
        services: ["Animación", "Piscina", "Discoteca", "Comidas tipo buffet", "Pie de pista"],
        amenities: [
          "Piscina interior climatizada",
          "Gimnasio",
          "Cine",
          "Sala de juegos",
          "Discoteca",
          "Bar con vistas",
          "Futbolines y billar",
        ],
        map_query: "Alp Hotel Masella, Avenida Josep Maria Bosch Aymerich, 17538 Alp, Girona",
      },
    },
    resort: {
      name: "Masella",
      subtitle: "La joya escondida del esquí español",
      highlights: [
        "Pistas largas entre pinos, con un ambiente que en España no encontrarás en otra estación.",
        "El mayor desnivel esquiable de España — sensación de estar en los Alpes sin salir del país.",
        "Amplia zona debutantes al lado del hotel, ideal para primer contacto con la nieve.",
        "El mayor dominio de esquí nocturno de la península, por si os apetece una bajada distinta.",
      ],
      stats: {
        skiable_km: 74,
        slopes_total: 65,
        slopes_breakdown: { green: 9, blue: 24, red: 22, black: 10 },
        snowmaking_km: 53,
        altitude: "1.600 – 2.535 m",
      },
      extra_info: {
        description:
          "La estación de Masella es una de las joyas desconocidas del esquí en España. Sorprende al visitante por la belleza de sus largas pistas entre pinos, sin igual en todo el país. Ofrece además el mayor desnivel de España y el mayor dominio de esquí nocturno de la península.",
        connections:
          "Conectada con La Molina formando Alp2500, el segundo dominio esquiable unido más grande de España con 145 km de pistas combinadas.",
        note: "Ampliación de forfait a La Molina disponible como suplemento opcional.",
        map_query: "Masella, 17538 Alp, Girona",
      },
    },
    intro:
      "El primer puente del invierno con nieve fresca, aire seco de montaña, y esa promesa de tranquilidad que empieza cuando dejas la maleta en el hotel. Este puente de la Inmaculada, os llevamos a Masella con todo pensado — vosotros solo tenéis que llegar.",
    pain_hook:
      "¿Te suena esa sensación de acabar el puente más cansado que empezaste? Aquí no. Cuatro días para respirar, esquiar sin colas, y darle a los niños uno de esos recuerdos que se guardan para siempre.",
    prices: [
      { label: "Adulto", amount: 498 },
      { label: "Joven 13–24 años", amount: 478 },
      { label: "Niño 7–12 años", amount: 398, note: "En habitación con dos adultos" },
      { label: "Niño 4–6 años", amount: 298, note: "En habitación con dos adultos" },
      { label: "Niño 0–3 años", amount: 0, note: "Gratuito, en habitación con dos adultos", free: true },
    ],
    includes: [
      "Alojamiento 4 noches a pie de pista en el Alp Hotel Masella 3★",
      "Media pensión (desayuno y cena buffet)",
      "Forfait Masella 4 días (excepto niños 0-3 años)",
      "Actividades por las tardes para los niños, supervisadas",
      "Guía Club Amistad y personal de apoyo en destino",
      "Atención personalizada antes, durante y después del viaje",
    ],
    supplements: [
      { label: "Clases de esquí adulto (2 h/día)", amount: 118 },
      { label: "Clases de esquí niños 6–14 años (todo el día)", amount: 198 },
      { label: "Clases de esquí niños 4–5 años (todo el día)", amount: 378 },
      { label: "Alquiler de equipo completo adulto", amount: 93 },
      { label: "Alquiler de equipo completo niño 7–17 años", amount: 80 },
      { label: "Alquiler de equipo completo niño 0–6 años", amount: 58 },
      { label: "Comida del mediodía niños con clases", amount: 59 },
      { label: "Seguro de anulación", amount: 12 },
      { label: "Ampliación de forfait a La Molina", amount: 35, note: "Niños 4-6 años: 8 €" },
    ],
    notes: [
      "No incluye tasas de estancia (aproximadamente 4 €/adulto).",
      "El seguro de accidentes no está incluido — recomendamos su contratación.",
      "Viaje organizado y comercializado por Viajes Amitour · CIC.MA 841.",
    ],
    program: {
      classes: {
        intro:
          "Todas las clases están impartidas por monitores propios del Club Amistad, no por escuelas externas. Los grupos son reducidos y los niños comen con sus profesores en pista.",
        min_age: "4 años (estricto)",
        schedule: "Jornada completa de 10:00 a 16:00",
        groups: [
          { ages: "4–5 años", label: "Esquí Mimo", group_size: "Grupos de 3 a 5 alumnos" },
          { ages: "6–14 años", label: "Grupos por nivel", group_size: "Máximo 10 alumnos por grupo" },
        ],
        meal_note:
          "Los niños que asisten a clases comen con los profesores en pista de 10:00 a 16:00. La comida del mediodía es obligatoria si van a clases y se contrata como suplemento (59 €).",
      },
      evening_activities: {
        schedule: "De 18:00 a 20:00, todos los días",
        description:
          "Juegos y actividades supervisadas por nuestros monitores dentro del hotel. Abiertas a todos los niños tengan o no clases, y sin coste adicional. La participación es voluntaria — la tarde es vuestra para hacer lo que os apetezca.",
      },
      insurance: {
        included:
          "El forfait incluye un seguro obligatorio que cubre el correcto funcionamiento del remonte, pero no cubre accidentes en pista.",
        recommended: [
          "Seguro específico de accidentes de esquí para las pistas.",
          "Seguro de anulación (opcional, 12 € por persona, ofrecido por RACE).",
        ],
      },
      before_travel: [
        "Videollamada informativa con el coordinador del viaje unos días antes de la salida.",
        "Circular con todos los detalles del viaje enviada por email.",
        "Alergias, dietas especiales o cualquier requisito particular: indícalos al reservar en el campo de observaciones. Tanto el hotel como los restaurantes en pista los tienen previstos.",
      ],
    },
    booking_info: {
      deposit: "Señal de 100 € por persona al confirmar la reserva.",
      payment:
        "El resto se abona en cuotas — transferencia o efectivo en oficina — antes de la fecha límite que verás en tu panel privado (aprox. 2 semanas antes del viaje).",
      confirmation:
        "Recibes la confirmación por email y puedes consultarla en tu área privada. Antes del viaje mantenemos una videollamada con el coordinador y te enviamos la circular con todos los detalles.",
      discounts: [
        "5 % de descuento a clientes que ya han viajado con Club Amistad (aplicable sobre el paquete base).",
        "50 % de descuento en clases para el 3er niño y siguientes cuando inscribes 3 o más niños (sobre las clases de menor valor).",
      ],
      cancellation: [
        { when: "Desde la reserva hasta 31 días antes", amount: "15 € por persona" },
        { when: "Entre 30 y 22 días antes", amount: "100 € por persona" },
        { when: "Entre 21 y 15 días antes", amount: "50 % del paquete base" },
        { when: "Entre 14 y 8 días antes", amount: "75 % de la reserva total" },
        { when: "En los últimos 7 días", amount: "100 %" },
      ],
      guarantee:
        "Garantía poca nieve: cancelación sin penalización si la estación no puede abrir un mínimo de 15 km esquiables el primer día.",
    },
    faqs: [
      {
        q: "Es nuestra primera vez en la nieve con los niños, ¿es un buen sitio para empezar?",
        a: "Es probablemente el mejor destino para debutar en familia. El hotel está literalmente frente a las pistas — sin traslados en coche cargados de material — y la zona de debutantes es amplia, con poca pendiente y muy segura. Nuestros monitores llevan más de 50 años enseñando a niños que nunca antes habían pisado la nieve.",
      },
      {
        q: "¿Qué hacen los niños mientras yo esquío?",
        a: "Si contratáis las clases todo el día (opcional), pasan la jornada con nuestros monitores: aprenden, esquían y comen supervisados. Por las tardes hay actividades organizadas de 18:00 a 20:00 sin coste adicional, abiertas a todos los niños tengan o no clases. Si preferís no meter a los peques en clases, la piscina climatizada y la sala de juegos del hotel son un plan perfecto.",
      },
      {
        q: "Los niños de 0 a 3 años, ¿vienen gratis de verdad?",
        a: "Totalmente. No pagan alojamiento ni pensión si comparten habitación con dos adultos. Solo pagan si quieres alquilar equipo o clases para ellos.",
      },
      {
        q: "¿Puedo pagar en cómodos plazos?",
        a: "Sí. Se abona una señal de 100 € por persona para confirmar la plaza y el resto en cuotas hasta unas dos semanas antes del viaje. Escríbenos y te lo detallamos según vuestras fechas de reserva.",
      },
      {
        q: "¿Y si no hay nieve?",
        a: "Contamos con la garantía poca nieve: si la estación no puede abrir un mínimo de 15 km esquiables el primer día, cancelas sin penalización. Además, Masella tiene 53 km innivados, lo que asegura la temporada temprana.",
      },
      {
        q: "¿Puedo cambiar la fecha del viaje o acortarlo?",
        a: "Es un viaje grupal con fechas cerradas, por lo que no se modifican. Sí puedes añadir una noche antes o después según disponibilidad y con un coste adicional. Acortar la estancia no reduce el precio del paquete.",
      },
      {
        q: "¿Se pueden diseñar viajes personalizados fuera de estas fechas?",
        a: "Sí, podemos organizar viajes a medida en otras fechas o estaciones. Suelen ser más caros y no incluyen los beneficios Especial Familias (guía receptivo 24h, entrega de forfait en el hotel, clases jornada completa para niños, actividades gratuitas por las tardes). Escríbenos y lo estudiamos.",
      },
    ],
    seo_title:
      "Viaje a la nieve en Masella · Inmaculada 2026 (4-8 dic) | Club Amistad",
    seo_description:
      "Viaje organizado a la nieve en Masella para el puente de la Inmaculada 2026. Alp Hotel a pie de pista, forfait 4 días y monitores propios. Desde 298 € por niño 4–6 años; adulto 498 €.",
  },

  // Los siguientes son placeholders básicos hasta que se enriquezcan con las URLs originales.
  {
    slug: "cerler-navidad",
    extended: true,
    sold_out: true,
    external_id: 268,
    booking_url: "https://www.clubamistad.com/viajes-esqui/presupuesto/268",
    pdf_url: "/dossiers/cerler-navidad.pdf",
    name: "Cerler, Navidad",
    short_name: "Cerler",
    season: "Navidad",
    dates: "Del sábado 26 al miércoles 30 de diciembre de 2026",
    dates_short: "26 – 30 dic 2026",
    duration: "5 días / 4 noches",
    ski_days: 4,
    regimen: "Media pensión — desayuno y cena buffet",
    room_distribution: "Habitaciones de 2 a 5 personas",
    price_from: 278,
    price_label: "Desde 278 €/persona",
    family_basis: "2 adultos + 2 niños",
    hero_image: "/trips/cerler-navidad/hero.jpg",
    image: "/trips/cerler-navidad/01.jpg",
    gallery: [
      "/trips/cerler-navidad/01.jpg",
      "/trips/cerler-navidad/02.jpg",
      "/trips/cerler-navidad/03.jpg",
      "/trips/cerler-navidad/04.jpg",
      "/trips/cerler-navidad/05.jpg",
      "/trips/cerler-navidad/06.jpg",
    ],
    hotel: {
      name: "Hotel Monte Alba 3★",
      subtitle: "El más cercano a las pistas · piscina · animación infantil",
      address: "1 Parcela, Calle F, 60 · 22449 Cerler · Huesca",
      phone: "974 551 136",
      highlights: [
        "El hotel más cercano a las pistas de Cerler: a apenas 200 metros del telesilla El Molino.",
        "Piscina interior y programa de animación pensado para los peques.",
        "Habitaciones familiares hasta 5 personas, con opciones de litera o sofá-cama.",
        "Un “campamento base” práctico y cómodo para pisar la nieve nada más salir del hotel.",
      ],
      extra_info: {
        description:
          "El hotel Monte Alba es el más cercano a pistas en la estación de Cerler, a unos 200 metros de las taquillas, pistas y el telesilla del Molino, al que se puede acceder descendiendo por unas escaleras que dan al parking de la estación. Cuenta con piscina y un programa de animación para los más pequeños. Un hotel práctico y cómodo en un entorno privilegiado. La mayor parte de las habitaciones del hotel son de categoría estándar, con dos camas individuales o una cama de matrimonio (número limitado y bajo petición). Algunas de esas habitaciones incorporan un sofá-cama individual o una litera. En este último caso las habitaciones pueden alojar familias completas de cuatro miembros, pero el espacio resultante es muy limitado, tanto por espacio como por capacidad de armario. Por último, algunas habitaciones estándar más espaciosas pueden llegar a alojar familias de 5 miembros, al contar con una litera y una cama supletorias.",
        services: ["Pie de pista", "Piscina", "Buffet", "Animación", "Guardaesquís"],
        amenities: [
          "Piscina interior",
          "Programa de animación infantil",
          "Guardaesquís propio del hotel",
          "Comedor buffet",
        ],
        map_query: "Hotel Monte Alba, Calle F 60, 22449 Cerler, Huesca",
      },
    },
    resort: {
      name: "Cerler",
      subtitle: "El pueblo más alto de España · Valle de Benasque",
      highlights: [
        "80 km de pistas muy familiares, con amplias zonas para debutantes.",
        "Pistas que bajan hasta el mismo pueblo — bonito acabar el día esquiando al bar del valle.",
        "Enclave en el Valle de Benasque, rodeado de cumbres de más de 3.000 metros.",
        "Ambiente pirenaico auténtico, muy distinto al plástico de otras estaciones.",
      ],
      stats: {
        skiable_km: 80,
        slopes_total: 69,
        slopes_breakdown: { green: 10, blue: 19, red: 26, black: 14 },
        snowmaking_km: 40,
        altitude: "1.500 – 2.630 m",
      },
      extra_info: {
        description:
          "La estación de Cerler se encuentra situada en el Pirineo oscense. El Valle de Benasque ofrece una tradición montañera justificada por su marco sin igual en España de cumbres por encima de los 3.000 metros de altitud. Cerler es el pueblo más alto de España. La estación, con 80 km de pistas, es muy familiar, con amplias zonas para debutantes y pistas hasta el mismo pueblo.",
        connections:
          "Estación con 389 cañones de innivación artificial y 40 km innivados — garantía de nieve prácticamente asegurada durante toda la temporada.",
        note: "Perfecta para familias que buscan un ambiente pirenaico tradicional, sin la masificación de otras estaciones.",
        map_query: "Estación de Esquí Cerler, 22449 Cerler, Huesca",
      },
    },
    intro:
      "La Navidad cambia para siempre cuando los niños descubren la nieve. Cuatro días de esquí en el Pirineo aragonés, con hotel a pie de pista y un ambiente familiar auténtico — muy lejos del bullicio de las grandes estaciones.",
    pain_hook:
      "Cuando todos esperan que la Navidad sea perfecta, lo último que necesitas es montar tú la logística. Llega, abre la maleta y empieza la película.",
    prices: [
      { label: "Adulto", amount: 648 },
      { label: "Niño 6–11 años", amount: 398, note: "En habitación con dos adultos" },
      { label: "Niño 3–5 años", amount: 278, note: "En habitación con dos adultos" },
      { label: "Niño 0–2 años", amount: 0, note: "En cuna, gratuito", free: true },
    ],
    includes: [
      "Alojamiento 4 noches a pie de pista en el Hotel Monte Alba 3★",
      "Media pensión (desayuno y cena buffet)",
      "Forfait Cerler 4 días (excepto niños 0-2 años)",
      "Actividades por las tardes para los niños, supervisadas",
      "Guía Club Amistad y personal de apoyo en destino",
      "Atención personalizada antes, durante y después del viaje",
    ],
    supplements: [
      { label: "Clases de esquí adulto (2 h/día)", amount: 118 },
      { label: "Clases de esquí niños 6–14 años (todo el día)", amount: 218 },
      { label: "Clases de esquí niños 4–5 años (todo el día)", amount: 398 },
      { label: "Alquiler de equipo completo adulto (sin casco)", amount: 79 },
      { label: "Alquiler de equipo completo niño (con casco)", amount: 79 },
      { label: "Comida del mediodía — menú plato del día", amount: 59 },
      { label: "Seguro de anulación", amount: 12 },
    ],
    notes: [
      "El precio no incluye seguros — recomendamos contratar seguro de accidentes específico de esquí.",
      "Viaje organizado y comercializado por Viajes Amitour · CIC.MA 841.",
    ],
    program: {
      classes: {
        intro:
          "Todas las clases están impartidas por monitores propios del Club Amistad, no por escuelas externas. Los grupos son reducidos y los niños comen con sus profesores en pista.",
        min_age: "4 años cumplidos (estricto — no se admite “casi 4 años”)",
        schedule: "Jornada completa de 10:00 a 16:00",
        groups: [
          { ages: "4–5 años", label: "Esquí Mimo", group_size: "Grupos de 3 a 5 alumnos" },
          { ages: "6–14 años", label: "Grupos por nivel", group_size: "Máximo 10 alumnos por grupo" },
        ],
        meal_note:
          "Los niños que asisten a clases comen con sus profesores en pista de 10:00 a 16:00. La comida del mediodía es obligatoria si van a clases y se contrata como suplemento (59 €).",
      },
      evening_activities: {
        schedule: "De 18:00 a 20:00, todos los días",
        description:
          "Juegos y actividades supervisadas por nuestros monitores dentro del hotel. Abiertas a todos los niños tengan o no clases, y sin coste adicional. La participación es voluntaria — la tarde es vuestra para hacer lo que os apetezca.",
      },
      insurance: {
        included:
          "El forfait incluye un seguro obligatorio que cubre el correcto funcionamiento del remonte, pero no cubre accidentes en pista.",
        recommended: [
          "Seguro específico de accidentes de esquí para las pistas (ofrecido por RACE).",
          "Seguro de anulación (12 € por persona, contratable al reservar o en las 48 h siguientes).",
        ],
      },
      before_travel: [
        "Videollamada informativa con el coordinador del viaje unos días antes de la salida.",
        "Circular con todos los detalles del viaje enviada por email.",
        "Alergias, dietas especiales o cualquier requisito particular: indícalos al reservar en el campo de observaciones. Tanto el hotel como los restaurantes en pista los tienen previstos.",
      ],
    },
    booking_info: {
      deposit: "Señal de 100 € por persona al confirmar la reserva.",
      payment:
        "El resto se abona en cuotas — transferencia o efectivo en oficina — antes de la fecha límite que verás en tu panel privado (aprox. 2 semanas antes del viaje).",
      confirmation:
        "Recibes la confirmación por email y puedes consultarla en tu área privada. Antes del viaje mantenemos una videollamada con el coordinador y te enviamos la circular con todos los detalles.",
      discounts: [
        "5 % de descuento a clientes que ya han viajado con Club Amistad (aplicable sobre el paquete base, no sobre los suplementos).",
        "50 % de descuento en clases para el 3er niño y siguientes cuando inscribes 3 o más niños (sobre las clases de menor valor).",
      ],
      cancellation: [
        { when: "Desde la reserva hasta 31 días antes", amount: "15 € por persona" },
        { when: "Entre 30 y 22 días antes", amount: "100 € por persona" },
        { when: "Entre 21 y 15 días antes", amount: "50 % del paquete base" },
        { when: "Entre 14 y 8 días antes", amount: "75 % de la reserva total" },
        { when: "En los últimos 7 días", amount: "100 %" },
      ],
      guarantee:
        "Garantía poca nieve: cancelación sin penalización si la estación no puede abrir un mínimo de 15 km esquiables el primer día (según el parte diario de la estación).",
    },
    faqs: [
      {
        q: "Es nuestra primera vez esquiando con los niños, ¿es un buen sitio para empezar?",
        a: "Cerler es una de las mejores estaciones familiares del Pirineo. La zona debutantes es amplia y muy segura, con pistas que bajan hasta el mismo pueblo. Nuestros monitores llevan más de 50 años enseñando a niños que nunca antes habían pisado la nieve. El Monte Alba, a 200m del telesilla, es el hotel más cómodo para no tener que cargar con material.",
      },
      {
        q: "¿Qué hacen los niños mientras yo esquío?",
        a: "Si contratáis las clases todo el día (opcional), pasan la jornada con nuestros monitores: aprenden, esquían y comen supervisados de 10 a 16h. Por las tardes hay actividades organizadas de 18:00 a 20:00 sin coste, abiertas a todos los niños tengan o no clases. Si preferís no meter a los peques en clases, la piscina del hotel y el programa de animación son un plan perfecto.",
      },
      {
        q: "Los niños de 0 a 2 años, ¿vienen gratis de verdad?",
        a: "Totalmente. Los bebés en cuna no pagan alojamiento ni pensión. Solo pagarían si quieres alquilar equipo o inscribirles a clases (a partir de 4 años cumplidos).",
      },
      {
        q: "¿Puedo pagar en cómodos plazos?",
        a: "Sí. Se abona una señal de 100 € por persona para confirmar la plaza y el resto en cuotas hasta unas dos semanas antes del viaje. Escríbenos y te lo detallamos según vuestras fechas de reserva.",
      },
      {
        q: "¿Y si no hay nieve?",
        a: "Contamos con la garantía poca nieve: si la estación no puede abrir un mínimo de 15 km esquiables el primer día, cancelas sin penalización. Cerler cuenta con 389 cañones y 40 km innivados — nieve asegurada durante toda la temporada.",
      },
      {
        q: "¿Puedo cambiar la fecha del viaje o acortarlo?",
        a: "Es un viaje grupal con fechas cerradas, por lo que no se modifican. Sí puedes añadir una noche antes o después según disponibilidad y con un coste adicional. Acortar la estancia no reduce el precio del paquete.",
      },
      {
        q: "¿Se pueden diseñar viajes personalizados fuera de estas fechas?",
        a: "Sí, podemos organizar viajes a medida en otras fechas o estaciones. Suelen ser más caros y no incluyen los beneficios Especial Familias (guía receptivo 24h, entrega de forfait en el hotel, clases jornada completa para niños, actividades gratuitas por las tardes). Escríbenos y lo estudiamos.",
      },
    ],
    seo_title:
      "Viaje a la nieve en Cerler · Navidad 2026 (26-30 dic) | Club Amistad",
    seo_description:
      "Plazas agotadas: esta salida está completa. Viaje familiar a la nieve en Cerler estas Navidades 2026. Hotel Monte Alba a pie de pista, forfait 4 días y monitores propios.",
  },
  {
    slug: "masella-fin-de-ano",
    extended: true,
    external_id: 264,
    booking_url: "https://www.clubamistad.com/viajes-esqui/presupuesto/264",
    pdf_url: "/dossiers/masella-fin-de-ano.pdf",
    name: "Masella–La Molina, Fin de Año",
    short_name: "Masella",
    season: "Fin de Año",
    dates: "Del lunes 28 de diciembre de 2026 al sábado 2 de enero de 2027",
    dates_short: "28 dic 2026 – 2 ene 2027",
    duration: "6 días / 5 noches",
    ski_days: 4,
    regimen: "Media pensión — desayuno y cena buffet · La noche del 31 la celebramos juntos",
    room_distribution: "Habitaciones de 2 a 6 personas",
    price_from: 428,
    price_label: "Desde 428 €/persona",
    family_basis: "2 adultos + 2 niños",
    hero_image: "/trips/masella-fin-de-ano/hero.jpg",
    image: "/trips/masella-fin-de-ano/01.jpg",
    gallery: [
      "/trips/masella-fin-de-ano/01.jpg",
      "/trips/masella-fin-de-ano/02.jpg",
      "/trips/masella-fin-de-ano/03.jpg",
      "/trips/masella-fin-de-ano/04.jpg",
      "/trips/masella-fin-de-ano/05.jpg",
      "/trips/masella-fin-de-ano/06.jpg",
    ],
    hotel: {
      name: "Alp Hotel Masella 3★",
      subtitle: "A 300 m de la base · piscina climatizada · cine, sala de juegos y discoteca",
      address: "Avenida de Josep Maria Bosch Aymerich, s/n · 17538 Alp · Girona",
      phone: "972 144 201",
      highlights: [
        "Los niños bajan a desayunar y salen a la pista literalmente en la puerta del hotel.",
        "Cena de Nochevieja + cotillón de fin de año incluidos: la noche del 31 la celebramos juntos.",
        "Piscina interior climatizada, gimnasio, cine, sala de juegos y discoteca para las tardes.",
        "Habitaciones familiares para 2 a 6 personas, con litera o supletorias para 3-4 miembros.",
      ],
      extra_info: {
        description:
          "Este hotel está situado frente a las mismas pistas de Masella, a escasos metros de la zona de debutantes y remontes. Ideal para familias, tanto por la cercanía a pistas como por las actividades que se organizan tarde y noche para todas las edades. Todas las comidas son estilo buffet y cuenta con piscina interior climatizada, gimnasio y zonas de ocio (cine, sala de juegos y discoteca). La mayor virtud de este hotel es sin duda su situación, en la misma base de la estación. Apenas 300 metros separan su puerta principal de la base de la estación, su zona de debutantes y los remontes que dan acceso a las cotas altas. Las habitaciones son sencillas y funcionales. Las habitaciones estándar cuentan con dos camas individuales y un espacio donde se incorporan las supletorias, ya sea una con cama inferior o dos, con la litera correspondiente. Aunque estas habitaciones son ideales para alojar a familias de 3 o 4 miembros, el espacio libre una vez desplegadas las camas supletorias es muy limitado, así como su espacio de armarios. Para familias de 5 o más miembros el hotel cuenta con un número limitado de habitaciones familiares con dos habitáculos y un único cuarto de baño. Todas sus comidas se llevan a cabo con buffet en su amplio restaurante con vistas a la montaña. Cuenta además con un amplio salón con bar, futbolines y villares. En esta zona se lleva a cabo normalmente la animación del hotel durante las noches de la temporada de invierno.",
        services: ["Animación", "Piscina", "Discoteca", "Comidas tipo buffet", "Pie de pista"],
        amenities: [
          "Piscina interior climatizada",
          "Gimnasio",
          "Cine",
          "Sala de juegos",
          "Discoteca",
          "Bar con vistas",
          "Futbolines y billar",
        ],
        map_query: "Alp Hotel Masella, Avenida Josep Maria Bosch Aymerich, 17538 Alp, Girona",
      },
    },
    resort: {
      name: "Masella – La Molina",
      subtitle: "Dominio Alp2500 · 145 km de pistas conectadas",
      highlights: [
        "Alp2500: segundo mayor dominio esquiable unido de España — 145 km entre Masella y La Molina.",
        "Pistas largas entre pinos, con un ambiente que en España no encontrarás en otra estación.",
        "El mayor desnivel esquiable de España y el mayor dominio de esquí nocturno de la península.",
        "De las primeras estaciones en abrir cada temporada y las últimas en cerrar.",
      ],
      stats: {
        skiable_km: 74,
        slopes_total: 65,
        slopes_breakdown: { green: 9, blue: 24, red: 22, black: 10 },
        snowmaking_km: 53,
        altitude: "1.600 – 2.535 m",
      },
      extra_info: {
        description:
          "La estación de Masella es una de las joyas desconocidas del esquí en España. Sorprende al visitante por la belleza de sus largas pistas entre pinos, sin igual en todo el país. Ofrece además el mayor desnivel de España y el mayor dominio de esquí nocturno de la península. Es de las estaciones que antes abren cada temporada y de las que más y mejor aguanta la nieve, cerrando tradicionalmente de las últimas.",
        connections:
          "Conectada con La Molina formando Alp2500: 145 km de pistas combinadas, el segundo mayor dominio esquiable unido de España.",
        note: "El forfait incluido en el viaje es el de Masella. La ampliación al dominio completo Alp2500 (con La Molina) está disponible como suplemento opcional (35 €, niños 4-6 años: 8 €).",
        map_query: "Masella, 17538 Alp, Girona",
      },
    },
    intro:
      "Despide el año esquiando bajo las estrellas y recibe el siguiente con uvas, cotillón y los niños riendo. Cinco noches en pleno dominio Alp2500 — 145 km conectados entre Masella y La Molina — para una Nochevieja diferente, sin reservas imposibles ni cenas estresantes.",
    pain_hook:
      "Olvídate de reservar restaurante, montar cena y discutir el “¿y los niños dónde?”. Aquí, la noche del 31 está pensada para que solo la celebréis.",
    prices: [
      { label: "Adulto", amount: 678 },
      { label: "Joven 13–24 años", amount: 658 },
      { label: "Niño 7–12 años", amount: 528, note: "En habitación con dos adultos" },
      { label: "Niño 4–6 años", amount: 428, note: "En habitación con dos adultos" },
      { label: "Niño 0–3 años", amount: 0, note: "Gratuito, en habitación con dos adultos", free: true },
    ],
    includes: [
      "Alojamiento 5 noches a pie de pista en el Alp Hotel Masella 3★",
      "Media pensión (desayuno y cena buffet)",
      "Forfait Masella 4 días (excepto niños 0-3 años)",
      "Cena de Nochevieja + cotillón de fin de año",
      "Actividades por las tardes para los niños, supervisadas",
      "Guía Club Amistad y personal de apoyo en destino",
      "Atención personalizada antes, durante y después del viaje",
    ],
    supplements: [
      { label: "Clases de esquí adulto (2 h/día)", amount: 128 },
      { label: "Clases de esquí niños 6–14 años (todo el día)", amount: 228 },
      { label: "Clases de esquí niños 4–5 años (todo el día)", amount: 398 },
      { label: "Alquiler de equipo completo adulto", amount: 93 },
      { label: "Alquiler de equipo completo niño 7–17 años", amount: 80 },
      { label: "Alquiler de equipo completo niño 0–6 años", amount: 58 },
      { label: "Comida del mediodía niños con clases", amount: 49 },
      { label: "Seguro de anulación", amount: 12 },
      { label: "Ampliación de forfait a La Molina (Alp2500)", amount: 35, note: "Niños 4-6 años: 8 €" },
    ],
    notes: [
      "No incluye tasas de estancia (aproximadamente 5 €/adulto).",
      "El seguro de accidentes no está incluido — recomendamos su contratación.",
      "Viaje organizado y comercializado por Viajes Amitour · CIC.MA 841.",
    ],
    program: {
      classes: {
        intro:
          "Todas las clases están impartidas por monitores propios del Club Amistad, no por escuelas externas. Los grupos son reducidos y los niños comen con sus profesores en pista.",
        min_age: "4 años cumplidos (estricto — no se admite “casi 4 años”)",
        schedule: "Jornada completa de 10:00 a 16:00",
        groups: [
          { ages: "4–5 años", label: "Esquí Mimo", group_size: "Grupos de 3 a 5 alumnos" },
          { ages: "6–14 años", label: "Grupos por nivel", group_size: "Máximo 10 alumnos por grupo" },
        ],
        meal_note:
          "Los niños que asisten a clases comen con sus profesores en pista de 10:00 a 16:00. La comida del mediodía es obligatoria si van a clases y se contrata como suplemento (49 €).",
      },
      evening_activities: {
        schedule: "De 18:00 a 20:00, todos los días · noche del 31 fiesta especial",
        description:
          "Juegos y actividades supervisadas por nuestros monitores dentro del hotel, incluidas y voluntarias. La noche del 31 tenemos cena de Nochevieja + cotillón para toda la familia, con animación pensada también para los peques. Fin de año sin dramas.",
      },
      insurance: {
        included:
          "El forfait incluye un seguro obligatorio que cubre el correcto funcionamiento del remonte, pero no cubre accidentes en pista.",
        recommended: [
          "Seguro específico de accidentes de esquí para las pistas (ofrecido por RACE).",
          "Seguro de anulación (12 € por persona, contratable al reservar o en las 48 h siguientes).",
        ],
      },
      before_travel: [
        "Videollamada informativa con el coordinador del viaje unos días antes de la salida.",
        "Circular con todos los detalles del viaje enviada por email.",
        "Alergias, dietas especiales o cualquier requisito particular: indícalos al reservar en el campo de observaciones. Tanto el hotel como los restaurantes en pista los tienen previstos.",
      ],
    },
    booking_info: {
      deposit: "Señal de 100 € por persona al confirmar la reserva.",
      payment:
        "El resto se abona en cuotas — transferencia o efectivo en oficina — antes de la fecha límite que verás en tu panel privado (aprox. 2 semanas antes del viaje).",
      confirmation:
        "Recibes la confirmación por email y puedes consultarla en tu área privada. Antes del viaje mantenemos una videollamada con el coordinador y te enviamos la circular con todos los detalles.",
      discounts: [
        "5 % de descuento a clientes que ya han viajado con Club Amistad (aplicable sobre el paquete base, no sobre los suplementos).",
        "50 % de descuento en clases para el 3er niño y siguientes cuando inscribes 3 o más niños (sobre las clases de menor valor).",
      ],
      cancellation: [
        { when: "Desde la reserva hasta 31 días antes", amount: "15 € por persona" },
        { when: "Entre 30 y 22 días antes", amount: "100 € por persona" },
        { when: "Entre 21 y 15 días antes", amount: "50 % del paquete base" },
        { when: "Entre 14 y 8 días antes", amount: "75 % de la reserva total" },
        { when: "En los últimos 7 días", amount: "100 %" },
      ],
      guarantee:
        "Garantía poca nieve: cancelación sin penalización si la estación no puede abrir un mínimo de 15 km esquiables el primer día (según el parte diario de la estación).",
    },
    faqs: [
      {
        q: "¿Qué implica exactamente lo de “la noche del 31 la celebramos juntos”?",
        a: "Cena de Nochevieja + cotillón incluidos en el hotel, con animación pensada también para las familias con niños. Cero estrés de reservar restaurante ni buscar canguro: los peques están integrados en la celebración, y vosotros podéis brindar tranquilos.",
      },
      {
        q: "¿Cómo funciona lo de la ampliación a La Molina?",
        a: "El forfait incluido en el viaje es el de Masella (74 km). Si queréis acceder al dominio completo Alp2500 unido con La Molina — 145 km conectados — se contrata como suplemento opcional: 35 € por persona, 8 € para niños de 4 a 6 años. Se activa el mismo forfait.",
      },
      {
        q: "Es nuestra primera vez esquiando con los niños, ¿es un buen sitio para empezar?",
        a: "Es de los mejores destinos para debutar en familia. El hotel está literalmente frente a las pistas y la zona de debutantes es amplia, con poca pendiente y muy segura. Nuestros monitores llevan más de 50 años enseñando a niños que nunca antes habían pisado la nieve.",
      },
      {
        q: "Los niños de 0 a 3 años, ¿vienen gratis de verdad?",
        a: "Totalmente. No pagan alojamiento ni pensión si comparten habitación con dos adultos. Solo pagarían si quieres alquilar equipo o inscribirles a clases (mínimo 4 años cumplidos).",
      },
      {
        q: "¿Puedo pagar en cómodos plazos?",
        a: "Sí. Se abona una señal de 100 € por persona para confirmar la plaza y el resto en cuotas hasta unas dos semanas antes del viaje.",
      },
      {
        q: "¿Y si no hay nieve?",
        a: "Contamos con la garantía poca nieve: si Masella no puede abrir un mínimo de 15 km esquiables el primer día, cancelas sin penalización. Además, la estación tiene 53 km innivados — nieve prácticamente asegurada.",
      },
      {
        q: "¿Puedo cambiar la fecha del viaje o acortarlo?",
        a: "Es un viaje grupal con fechas cerradas, por lo que no se modifican. Sí puedes añadir una noche antes o después según disponibilidad y con un coste adicional. Acortar la estancia no reduce el precio del paquete.",
      },
    ],
    seo_title:
      "Viaje a la nieve Masella-La Molina · Fin de Año 2026 | Club Amistad",
    seo_description:
      "Fin de Año en el dominio Masella-La Molina (Alp2500, 145 km). Alp Hotel a pie de pista, forfait 4 días y monitores propios. Alojamiento, media pensión y forfait incluidos.",
  },
  {
    slug: "cerler-fin-de-ano",
    extended: true,
    external_id: 267,
    booking_url: "https://www.clubamistad.com/viajes-esqui/presupuesto/267",
    pdf_url: "/dossiers/cerler-fin-de-ano.pdf",
    name: "Cerler, Fin de Año",
    short_name: "Cerler",
    season: "Fin de Año",
    dates: "Del miércoles 30 de diciembre de 2026 al lunes 4 de enero de 2027",
    dates_short: "30 dic 2026 – 4 ene 2027",
    duration: "6 días / 5 noches",
    ski_days: 4,
    regimen: "Media pensión — desayuno y cena buffet · cena especial de Nochevieja incluida",
    room_distribution: "Habitaciones de 2 a 5 personas",
    price_from: 348,
    price_label: "Desde 348 €/persona",
    family_basis: "2 adultos + 2 niños",
    hero_image: "/trips/cerler-fin-de-ano/hero.jpg",
    image: "/trips/cerler-fin-de-ano/01.jpg",
    gallery: [
      "/trips/cerler-fin-de-ano/01.jpg",
      "/trips/cerler-fin-de-ano/02.jpg",
      "/trips/cerler-fin-de-ano/03.jpg",
      "/trips/cerler-fin-de-ano/04.jpg",
      "/trips/cerler-fin-de-ano/05.jpg",
      "/trips/cerler-fin-de-ano/06.jpg",
    ],
    hotel: {
      name: "Hotel Monte Alba 3★",
      subtitle: "El más cercano a las pistas · piscina · animación infantil · cena de Nochevieja incluida",
      address: "1 Parcela, Calle F, 60 · 22449 Cerler · Huesca",
      phone: "974 551 136",
      highlights: [
        "El hotel más cercano a las pistas de Cerler: a apenas 200 metros del telesilla El Molino.",
        "Cena especial de Nochevieja incluida en el hotel (cotillón no incluido).",
        "Piscina interior y programa de animación pensado para los peques.",
        "Habitaciones familiares hasta 5 personas, con opciones de litera o sofá-cama.",
      ],
      extra_info: {
        description:
          "El hotel Monte Alba es el más cercano a pistas en la estación de Cerler, a unos 200 metros de las taquillas, pistas y el telesilla del Molino, al que se puede acceder descendiendo por unas escaleras que dan al parking de la estación. Cuenta con piscina y un programa de animación para los más pequeños. Un hotel práctico y cómodo en un entorno privilegiado. La mayor parte de las habitaciones del hotel son de categoría estándar, con dos camas individuales o una cama de matrimonio (número limitado y bajo petición). Algunas de esas habitaciones incorporan un sofá-cama individual o una litera. En este último caso las habitaciones pueden alojar familias completas de cuatro miembros, pero el espacio resultante es muy limitado, tanto por espacio como por capacidad de armario. Por último, algunas habitaciones estándar más espaciosas pueden llegar a alojar familias de 5 miembros, al contar con una litera y una cama supletorias.",
        services: ["Pie de pista", "Piscina", "Buffet", "Animación", "Guardaesquís"],
        amenities: [
          "Piscina interior",
          "Programa de animación infantil",
          "Guardaesquís propio del hotel",
          "Comedor buffet",
          "Salón con bar y ambiente",
        ],
        map_query: "Hotel Monte Alba, Calle F 60, 22449 Cerler, Huesca",
      },
    },
    resort: {
      name: "Cerler",
      subtitle: "El pueblo más alto de España · Valle de Benasque",
      highlights: [
        "80 km de pistas muy familiares, con amplias zonas para debutantes.",
        "Pistas que bajan hasta el mismo pueblo — bonito acabar el día esquiando al bar del valle.",
        "Enclave en el Valle de Benasque, rodeado de cumbres de más de 3.000 metros.",
        "389 cañones y 40 km innivados: nieve prácticamente asegurada toda la temporada.",
      ],
      stats: {
        skiable_km: 80,
        slopes_total: 69,
        slopes_breakdown: { green: 10, blue: 19, red: 26, black: 14 },
        snowmaking_km: 40,
        altitude: "1.500 – 2.630 m",
      },
      extra_info: {
        description:
          "La estación de Cerler se encuentra situada en el Pirineo oscense. El Valle de Benasque ofrece una tradición montañera justificada por su marco sin igual en España de cumbres por encima de los 3.000 metros de altitud. Cerler es el pueblo más alto de España. La estación, con 80 km de pistas, es muy familiar, con amplias zonas para debutantes y pistas hasta el mismo pueblo.",
        connections:
          "Estación con 389 cañones de innivación artificial y 40 km innivados — garantía de nieve prácticamente asegurada durante toda la temporada.",
        note: "Perfecta para familias que buscan un ambiente pirenaico tradicional, sin la masificación de otras estaciones.",
        map_query: "Estación de Esquí Cerler, 22449 Cerler, Huesca",
      },
    },
    intro:
      "Cinco noches en el corazón del Pirineo oscense para despedir el año esquiando y darle la bienvenida al siguiente con los niños riendo. Una Nochevieja de montaña — auténtica, familiar, sin agobios de reservas ni cenas imposibles.",
    pain_hook:
      "Las vacaciones largas también cansan cuando toca planificarlo tú todo. Nosotros nos ocupamos del hotel, el forfait, las clases y la cena del 31 — vosotros solo esquiáis, brindáis y descansáis.",
    prices: [
      { label: "Adulto", amount: 768 },
      { label: "Niño 6–11 años", amount: 468, note: "En habitación con dos adultos" },
      { label: "Niño 3–5 años", amount: 348, note: "En habitación con dos adultos" },
      { label: "Niño 0–2 años", amount: 0, note: "En cuna, gratuito", free: true },
    ],
    includes: [
      "Alojamiento 5 noches a pie de pista en el Hotel Monte Alba 3★",
      "Media pensión (desayuno y cena buffet)",
      "Forfait Cerler 4 días (excepto niños 0-2 años)",
      "Cena especial de Nochevieja (cotillón no incluido)",
      "Actividades por las tardes para los niños, supervisadas",
      "Guía Club Amistad y personal de apoyo en destino",
      "Atención personalizada antes, durante y después del viaje",
    ],
    supplements: [
      { label: "Clases de esquí adulto (2 h/día)", amount: 128 },
      { label: "Clases de esquí niños 6–14 años (todo el día)", amount: 228 },
      { label: "Clases de esquí niños 4–5 años (todo el día)", amount: 398 },
      { label: "Alquiler de equipo completo adulto (sin casco)", amount: 79 },
      { label: "Alquiler de equipo completo niño (con casco)", amount: 79 },
      { label: "Comida del mediodía — menú plato del día", amount: 59 },
      { label: "Seguro de anulación", amount: 12 },
    ],
    notes: [
      "El precio no incluye seguros — recomendamos contratar seguro de accidentes específico de esquí.",
      "La cena de Nochevieja está incluida; el cotillón no está incluido.",
      "Viaje organizado y comercializado por Viajes Amitour · CIC.MA 841.",
    ],
    program: {
      classes: {
        intro:
          "Todas las clases están impartidas por monitores propios del Club Amistad, no por escuelas externas. Los grupos son reducidos y los niños comen con sus profesores en pista.",
        min_age: "4 años cumplidos (estricto — no se admite “casi 4 años”)",
        schedule: "Jornada completa de 10:00 a 16:00",
        groups: [
          { ages: "4–5 años", label: "Esquí Mimo", group_size: "Grupos de 3 a 5 alumnos" },
          { ages: "6–14 años", label: "Grupos por nivel", group_size: "Máximo 10 alumnos por grupo" },
        ],
        meal_note:
          "Los niños que asisten a clases comen con sus profesores en pista de 10:00 a 16:00. La comida del mediodía es obligatoria si van a clases y se contrata como suplemento (59 €).",
      },
      evening_activities: {
        schedule: "De 18:00 a 20:00, todos los días · noche del 31 cena especial",
        description:
          "Juegos y actividades supervisadas por nuestros monitores dentro del hotel, incluidas y voluntarias. La noche del 31 tenemos cena especial de Nochevieja para toda la familia en el hotel. Fin de año sin dramas de reservar restaurante.",
      },
      insurance: {
        included:
          "El forfait incluye un seguro obligatorio que cubre el correcto funcionamiento del remonte, pero no cubre accidentes en pista.",
        recommended: [
          "Seguro específico de accidentes de esquí para las pistas (ofrecido por RACE).",
          "Seguro de anulación (12 € por persona, contratable al reservar o en las 48 h siguientes).",
        ],
      },
      before_travel: [
        "Videollamada informativa con el coordinador del viaje unos días antes de la salida.",
        "Circular con todos los detalles del viaje enviada por email.",
        "Alergias, dietas especiales o cualquier requisito particular: indícalos al reservar en el campo de observaciones. Tanto el hotel como los restaurantes en pista los tienen previstos.",
      ],
    },
    booking_info: {
      deposit: "Señal de 100 € por persona al confirmar la reserva.",
      payment:
        "El resto se abona en cuotas — transferencia o efectivo en oficina — antes de la fecha límite que verás en tu panel privado (aprox. 2 semanas antes del viaje).",
      confirmation:
        "Recibes la confirmación por email y puedes consultarla en tu área privada. Antes del viaje mantenemos una videollamada con el coordinador y te enviamos la circular con todos los detalles.",
      discounts: [
        "5 % de descuento a clientes que ya han viajado con Club Amistad (aplicable sobre el paquete base, no sobre los suplementos).",
        "50 % de descuento en clases para el 3er niño y siguientes cuando inscribes 3 o más niños (sobre las clases de menor valor).",
      ],
      cancellation: [
        { when: "Desde la reserva hasta 31 días antes", amount: "15 € por persona" },
        { when: "Entre 30 y 22 días antes", amount: "100 € por persona" },
        { when: "Entre 21 y 15 días antes", amount: "50 % del paquete base" },
        { when: "Entre 14 y 8 días antes", amount: "75 % de la reserva total" },
        { when: "En los últimos 7 días", amount: "100 %" },
      ],
      guarantee:
        "Garantía poca nieve: cancelación sin penalización si la estación no puede abrir un mínimo de 15 km esquiables el primer día (según el parte diario de la estación).",
    },
    faqs: [
      {
        q: "¿Qué implica exactamente la cena de Nochevieja incluida?",
        a: "Cena especial de Nochevieja en el hotel para toda la familia. El cotillón no está incluido en el precio, pero el hotel suele ofrecer ambiente y música. Cero estrés de reservar restaurante ni buscar canguro: los peques cenan con vosotros y las actividades del hotel siguen la noche del 31.",
      },
      {
        q: "Es nuestra primera vez esquiando con los niños, ¿es un buen sitio para empezar?",
        a: "Cerler es una de las mejores estaciones familiares del Pirineo. La zona debutantes es amplia y muy segura, con pistas que bajan hasta el mismo pueblo. El Monte Alba, a 200 m del telesilla, es el hotel más cómodo para no tener que cargar con material.",
      },
      {
        q: "¿Qué hacen los niños mientras yo esquío?",
        a: "Si contratáis las clases todo el día (opcional), pasan la jornada con nuestros monitores: aprenden, esquían y comen supervisados de 10 a 16h. Por las tardes hay actividades organizadas de 18:00 a 20:00 sin coste. Si preferís no meter a los peques en clases, la piscina del hotel y el programa de animación son un plan perfecto.",
      },
      {
        q: "Los niños de 0 a 2 años, ¿vienen gratis de verdad?",
        a: "Totalmente. Los bebés en cuna no pagan alojamiento ni pensión. Solo pagarían si quieres alquilar equipo o inscribirles a clases (a partir de 4 años cumplidos).",
      },
      {
        q: "¿Puedo pagar en cómodos plazos?",
        a: "Sí. Se abona una señal de 100 € por persona para confirmar la plaza y el resto en cuotas hasta unas dos semanas antes del viaje.",
      },
      {
        q: "¿Y si no hay nieve?",
        a: "Contamos con la garantía poca nieve: si Cerler no puede abrir un mínimo de 15 km esquiables el primer día, cancelas sin penalización. La estación cuenta con 389 cañones y 40 km innivados — nieve asegurada.",
      },
      {
        q: "¿Puedo cambiar la fecha del viaje o acortarlo?",
        a: "Es un viaje grupal con fechas cerradas, por lo que no se modifican. Sí puedes añadir una noche antes o después según disponibilidad y con un coste adicional. Acortar la estancia no reduce el precio del paquete.",
      },
    ],
    seo_title:
      "Viaje a la nieve en Cerler · Fin de Año 2026 (30 dic-4 ene) | Club Amistad",
    seo_description:
      "Fin de Año en Cerler con hotel Monte Alba a pie de pista, forfait 4 días y monitores propios. Viaje organizado en familia con actividades para los niños.",
  },
  {
    slug: "cerler-reyes",
    extended: true,
    external_id: 269,
    booking_url: "https://www.clubamistad.com/viajes-esqui/presupuesto/269",
    pdf_url: "/dossiers/cerler-reyes.pdf",
    name: "Cerler, Reyes",
    short_name: "Cerler",
    season: "Reyes",
    dates: "Del miércoles 6 al domingo 10 de enero de 2027",
    dates_short: "6 – 10 ene 2027",
    duration: "5 días / 4 noches",
    ski_days: 4,
    regimen: "Media pensión — desayuno y cena buffet",
    room_distribution: "Habitaciones de 2 a 5 personas",
    price_from: 258,
    price_label: "Desde 258 €/persona",
    family_basis: "2 adultos + 2 niños",
    hero_image: "/trips/cerler-reyes/hero.jpg",
    image: "/trips/cerler-reyes/01.jpg",
    gallery: [
      "/trips/cerler-reyes/01.jpg",
      "/trips/cerler-reyes/02.jpg",
      "/trips/cerler-reyes/03.jpg",
      "/trips/cerler-reyes/04.jpg",
      "/trips/cerler-reyes/05.jpg",
      "/trips/cerler-reyes/06.jpg",
    ],
    hotel: {
      name: "Hotel Monte Alba 3★",
      subtitle: "El más cercano a las pistas · piscina · animación infantil",
      address: "1 Parcela, Calle F, 60 · 22449 Cerler · Huesca",
      phone: "974 551 136",
      highlights: [
        "El hotel más cercano a las pistas de Cerler: a apenas 200 metros del telesilla El Molino.",
        "Piscina interior y programa de animación pensado para los peques.",
        "Habitaciones familiares hasta 5 personas, con opciones de litera o sofá-cama.",
        "Un “campamento base” práctico y cómodo para pisar la nieve nada más salir del hotel.",
      ],
      extra_info: {
        description:
          "El hotel Monte Alba es el más cercano a pistas en la estación de Cerler, a unos 200 metros de las taquillas, pistas y el telesilla del Molino, al que se puede acceder descendiendo por unas escaleras que dan al parking de la estación. Cuenta con piscina y un programa de animación para los más pequeños. Un hotel práctico y cómodo en un entorno privilegiado. La mayor parte de las habitaciones del hotel son de categoría estándar, con dos camas individuales o una cama de matrimonio (número limitado y bajo petición). Algunas de esas habitaciones incorporan un sofá-cama individual o una litera. En este último caso las habitaciones pueden alojar familias completas de cuatro miembros, pero el espacio resultante es muy limitado, tanto por espacio como por capacidad de armario. Por último, algunas habitaciones estándar más espaciosas pueden llegar a alojar familias de 5 miembros, al contar con una litera y una cama supletorias.",
        services: ["Pie de pista", "Piscina", "Buffet", "Animación", "Guardaesquís"],
        amenities: ["Piscina interior", "Programa de animación infantil", "Guardaesquís propio del hotel", "Comedor buffet"],
        map_query: "Hotel Monte Alba, Calle F 60, 22449 Cerler, Huesca",
      },
    },
    resort: {
      name: "Cerler",
      subtitle: "El pueblo más alto de España · Valle de Benasque",
      highlights: [
        "80 km de pistas muy familiares, con amplias zonas para debutantes.",
        "Pistas que bajan hasta el mismo pueblo — bonito acabar el día esquiando al bar del valle.",
        "Enclave en el Valle de Benasque, rodeado de cumbres de más de 3.000 metros.",
        "389 cañones y 40 km innivados: nieve prácticamente asegurada toda la temporada.",
      ],
      stats: {
        skiable_km: 80,
        slopes_total: 69,
        slopes_breakdown: { green: 10, blue: 19, red: 26, black: 14 },
        snowmaking_km: 40,
        altitude: "1.500 – 2.630 m",
      },
      extra_info: {
        description:
          "La estación de Cerler se encuentra situada en el Pirineo oscense. El Valle de Benasque ofrece una tradición montañera justificada por su marco sin igual en España de cumbres por encima de los 3.000 metros de altitud. Cerler es el pueblo más alto de España. La estación, con 80 km de pistas, es muy familiar, con amplias zonas para debutantes y pistas hasta el mismo pueblo.",
        connections:
          "Estación con 389 cañones de innivación artificial y 40 km innivados — garantía de nieve prácticamente asegurada durante toda la temporada.",
        note: "Perfecta para familias que buscan un ambiente pirenaico tradicional, sin la masificación de otras estaciones.",
        map_query: "Estación de Esquí Cerler, 22449 Cerler, Huesca",
      },
    },
    intro:
      "Los Reyes en el Pirineo aragonés: cuatro días para cerrar las vacaciones esquiando en Cerler, con hotel a pie de pista y ese ambiente familiar auténtico que hace que la vuelta al cole se retrase mentalmente unos días más.",
    pain_hook:
      "El “ya casi vuelta al cole” puede ser el mejor recuerdo del año. Nosotros nos ocupamos del hotel, del forfait y de las clases para que estos últimos días de vacaciones sean puro descanso y magia para los niños.",
    prices: [
      { label: "Adulto", amount: 578 },
      { label: "Niño 6–11 años", amount: 368, note: "En habitación con dos adultos" },
      { label: "Niño 3–5 años", amount: 258, note: "En habitación con dos adultos" },
      { label: "Niño 0–2 años", amount: 0, note: "En cuna, gratuito", free: true },
    ],
    includes: [
      "Alojamiento 4 noches a pie de pista en el Hotel Monte Alba 3★",
      "Media pensión (desayuno y cena buffet)",
      "Forfait Cerler 4 días (excepto niños 0-2 años)",
      "Actividades por las tardes para los niños, supervisadas",
      "Guía Club Amistad y personal de apoyo en destino",
      "Atención personalizada antes, durante y después del viaje",
    ],
    supplements: [
      { label: "Clases de esquí adulto (2 h/día)", amount: 118 },
      { label: "Clases de esquí niños 6–14 años (todo el día)", amount: 218 },
      { label: "Clases de esquí niños 4–5 años (todo el día)", amount: 398 },
      { label: "Alquiler de equipo completo adulto (sin casco)", amount: 79 },
      { label: "Alquiler de equipo completo niño (con casco)", amount: 79 },
      { label: "Comida del mediodía — menú plato del día", amount: 59 },
      { label: "Seguro de anulación", amount: 12 },
    ],
    notes: [
      "El precio no incluye seguros — recomendamos contratar seguro de accidentes específico de esquí.",
      "Viaje organizado y comercializado por Viajes Amitour · CIC.MA 841.",
    ],
    program: {
      classes: {
        intro:
          "Todas las clases están impartidas por monitores propios del Club Amistad, no por escuelas externas. Los grupos son reducidos y los niños comen con sus profesores en pista.",
        min_age: "4 años cumplidos (estricto — no se admite “casi 4 años”)",
        schedule: "Jornada completa de 10:00 a 16:00",
        groups: [
          { ages: "4–5 años", label: "Esquí Mimo", group_size: "Grupos de 3 a 5 alumnos" },
          { ages: "6–14 años", label: "Grupos por nivel", group_size: "Máximo 10 alumnos por grupo" },
        ],
        meal_note:
          "Los niños que asisten a clases comen con sus profesores en pista de 10:00 a 16:00. La comida del mediodía es obligatoria si van a clases y se contrata como suplemento (59 €).",
      },
      evening_activities: {
        schedule: "De 18:00 a 20:00, todos los días",
        description:
          "Juegos y actividades supervisadas por nuestros monitores dentro del hotel. Abiertas a todos los niños tengan o no clases, y sin coste adicional. La participación es voluntaria — la tarde es vuestra para hacer lo que os apetezca.",
      },
      insurance: {
        included:
          "El forfait incluye un seguro obligatorio que cubre el correcto funcionamiento del remonte, pero no cubre accidentes en pista.",
        recommended: [
          "Seguro específico de accidentes de esquí para las pistas (ofrecido por RACE).",
          "Seguro de anulación (12 € por persona, contratable al reservar o en las 48 h siguientes).",
        ],
      },
      before_travel: [
        "Videollamada informativa con el coordinador del viaje unos días antes de la salida.",
        "Circular con todos los detalles del viaje enviada por email.",
        "Alergias, dietas especiales o cualquier requisito particular: indícalos al reservar en el campo de observaciones. Tanto el hotel como los restaurantes en pista los tienen previstos.",
      ],
    },
    booking_info: {
      deposit: "Señal de 100 € por persona al confirmar la reserva.",
      payment:
        "El resto se abona en cuotas — transferencia o efectivo en oficina — antes de la fecha límite que verás en tu panel privado (aprox. 2 semanas antes del viaje).",
      confirmation:
        "Recibes la confirmación por email y puedes consultarla en tu área privada. Antes del viaje mantenemos una videollamada con el coordinador y te enviamos la circular con todos los detalles.",
      discounts: [
        "5 % de descuento a clientes que ya han viajado con Club Amistad (aplicable sobre el paquete base, no sobre los suplementos).",
        "50 % de descuento en clases para el 3er niño y siguientes cuando inscribes 3 o más niños (sobre las clases de menor valor).",
      ],
      cancellation: [
        { when: "Desde la reserva hasta 31 días antes", amount: "15 € por persona" },
        { when: "Entre 30 y 22 días antes", amount: "100 € por persona" },
        { when: "Entre 21 y 15 días antes", amount: "50 % del paquete base" },
        { when: "Entre 14 y 8 días antes", amount: "75 % de la reserva total" },
        { when: "En los últimos 7 días", amount: "100 %" },
      ],
      guarantee:
        "Garantía poca nieve: cancelación sin penalización si la estación no puede abrir un mínimo de 15 km esquiables el primer día (según el parte diario de la estación).",
    },
    faqs: [
      {
        q: "Es nuestra primera vez esquiando con los niños, ¿es un buen sitio para empezar?",
        a: "Cerler es una de las mejores estaciones familiares del Pirineo. La zona debutantes es amplia y muy segura, con pistas que bajan hasta el mismo pueblo. El Monte Alba, a 200 m del telesilla, es el hotel más cómodo para no tener que cargar con material.",
      },
      {
        q: "¿Qué hacen los niños mientras yo esquío?",
        a: "Si contratáis las clases todo el día (opcional), pasan la jornada con nuestros monitores: aprenden, esquían y comen supervisados de 10 a 16h. Por las tardes hay actividades organizadas de 18:00 a 20:00 sin coste. Si preferís no meter a los peques en clases, la piscina del hotel y el programa de animación son un plan perfecto.",
      },
      {
        q: "Los niños de 0 a 2 años, ¿vienen gratis de verdad?",
        a: "Totalmente. Los bebés en cuna no pagan alojamiento ni pensión. Solo pagarían si quieres alquilar equipo o inscribirles a clases (a partir de 4 años cumplidos).",
      },
      {
        q: "¿Puedo pagar en cómodos plazos?",
        a: "Sí. Se abona una señal de 100 € por persona para confirmar la plaza y el resto en cuotas hasta unas dos semanas antes del viaje.",
      },
      {
        q: "¿Y si no hay nieve?",
        a: "Contamos con la garantía poca nieve: si Cerler no puede abrir un mínimo de 15 km esquiables el primer día, cancelas sin penalización. La estación cuenta con 389 cañones y 40 km innivados — nieve asegurada.",
      },
      {
        q: "¿Puedo cambiar la fecha del viaje o acortarlo?",
        a: "Es un viaje grupal con fechas cerradas, por lo que no se modifican. Sí puedes añadir una noche antes o después según disponibilidad y con un coste adicional. Acortar la estancia no reduce el precio del paquete.",
      },
    ],
    seo_title:
      "Viaje a la nieve en Cerler · Reyes 2027 (6-10 ene) | Club Amistad",
    seo_description:
      "Viaje a la nieve para Reyes 2027 en Cerler. Hotel Monte Alba a pie de pista, forfait 4 días y monitores propios. Actividades por la tarde para los niños.",
  },
  {
    slug: "masella-reyes",
    extended: true,
    sold_out: true,
    external_id: 265,
    booking_url: "https://www.clubamistad.com/viajes-esqui/presupuesto/265",
    pdf_url: "/dossiers/masella-reyes.pdf",
    name: "Masella–La Molina, Reyes",
    short_name: "Masella",
    season: "Reyes",
    dates: "Del sábado 2 al miércoles 6 de enero de 2027",
    dates_short: "2 – 6 ene 2027",
    duration: "5 días / 4 noches",
    ski_days: 4,
    regimen: "Media pensión — desayuno y cena buffet",
    room_distribution: "Habitaciones de 2 a 6 personas",
    price_from: 338,
    price_label: "Desde 338 €/persona",
    family_basis: "2 adultos + 2 niños",
    hero_image: "/trips/masella-reyes/hero.jpg",
    image: "/trips/masella-reyes/01.jpg",
    gallery: [
      "/trips/masella-reyes/01.jpg",
      "/trips/masella-reyes/02.jpg",
      "/trips/masella-reyes/03.jpg",
      "/trips/masella-reyes/04.jpg",
      "/trips/masella-reyes/05.jpg",
      "/trips/masella-reyes/06.jpg",
    ],
    hotel: {
      name: "Alp Hotel Masella 3★",
      subtitle: "A 300 m de la base · piscina climatizada · llegada de SSMM los Reyes Magos",
      address: "Avenida de Josep Maria Bosch Aymerich, s/n · 17538 Alp · Girona",
      phone: "972 144 201",
      highlights: [
        "Los niños bajan a desayunar y salen a la pista literalmente en la puerta del hotel.",
        "Bajada especial de SSMM Los Reyes Magos por las pistas de Masella — ilusión asegurada.",
        "Piscina interior climatizada, gimnasio, cine, sala de juegos y discoteca para las tardes.",
        "Habitaciones familiares para 2 a 6 personas, con litera o supletorias para 3-4 miembros.",
      ],
      extra_info: {
        description:
          "Este hotel está situado frente a las mismas pistas de Masella, a escasos metros de la zona de debutantes y remontes. Ideal para familias, tanto por la cercanía a pistas como por las actividades que se organizan tarde y noche para todas las edades. Todas las comidas son estilo buffet y cuenta con piscina interior climatizada, gimnasio y zonas de ocio (cine, sala de juegos y discoteca). La mayor virtud de este hotel es sin duda su situación, en la misma base de la estación. Apenas 300 metros separan su puerta principal de la base de la estación, su zona de debutantes y los remontes que dan acceso a las cotas altas. Las habitaciones son sencillas y funcionales. Las habitaciones estándar cuentan con dos camas individuales y un espacio donde se incorporan las supletorias, ya sea una con cama inferior o dos, con la litera correspondiente. Aunque estas habitaciones son ideales para alojar a familias de 3 o 4 miembros, el espacio libre una vez desplegadas las camas supletorias es muy limitado, así como su espacio de armarios. Para familias de 5 o más miembros el hotel cuenta con un número limitado de habitaciones familiares con dos habitáculos y un único cuarto de baño. Todas sus comidas se llevan a cabo con buffet en su amplio restaurante con vistas a la montaña. Cuenta además con un amplio salón con bar, futbolines y villares. En esta zona se lleva a cabo normalmente la animación del hotel durante las noches de la temporada de invierno.",
        services: ["Animación", "Piscina", "Discoteca", "Comidas tipo buffet", "Pie de pista"],
        amenities: [
          "Piscina interior climatizada",
          "Gimnasio",
          "Cine",
          "Sala de juegos",
          "Discoteca",
          "Bar con vistas",
          "Futbolines y billar",
        ],
        map_query: "Alp Hotel Masella, Avenida Josep Maria Bosch Aymerich, 17538 Alp, Girona",
      },
    },
    resort: {
      name: "Masella – La Molina",
      subtitle: "Dominio Alp2500 · 145 km · bajada de los Reyes Magos por las pistas",
      highlights: [
        "Alp2500: segundo mayor dominio esquiable conectado de España — 145 km entre Masella y La Molina.",
        "6 remontes desembragables modernos y un completo parque de nieve en el sector Masella.",
        "Amplia zona de debutantes frente al alojamiento y largas pistas azules entre pinos.",
        "Bajada especial de los Reyes Magos por las pistas — momento mágico para los niños.",
      ],
      stats: {
        skiable_km: 145,
        slopes_total: 132,
        slopes_breakdown: { green: 29, blue: 44, red: 42, black: 17 },
        snowmaking_km: 95,
        altitude: "1.600 – 2.535 m",
      },
      extra_info: {
        description:
          "La unión de Masella y La Molina en un único dominio le convierte, con 145 km de pistas esquiables, en el segundo dominio conectado por pistas más grande de España. El sector de Masella cuenta con modernas instalaciones con 6 remontes desembragables y un completo parque de nieve. Disfruta de una zona de debutantes frente al alojamiento a pie de pista, largas pistas azules entre pinos o sus pistas rojas y negras a 2.500 metros.",
        connections:
          "Alp2500: 145 km de pistas combinadas (Masella + La Molina), 132 pistas totales y 95 km innivados — nieve prácticamente garantizada.",
        note: "El forfait incluido es de Masella (74 km). Ampliación al dominio completo Alp2500 disponible como suplemento opcional.",
        map_query: "Masella, 17538 Alp, Girona",
      },
    },
    intro:
      "Vive los Reyes en la nieve: la bajada de SSMM Los Reyes Magos por las pistas de Masella, regalos sobre los esquís y caras de ilusión que recordarás siempre. Cuatro días para cerrar las vacaciones con la escena más mágica del año.",
    pain_hook:
      "Ese “ya casi vuelta al cole” puede convertirse en el mejor recuerdo del curso. Una despedida de vacaciones serena, organizada y mágica para los niños — sin la resaca de fin de año.",
    prices: [
      { label: "Adulto", amount: 548 },
      { label: "Joven 13–24 años", amount: 518 },
      { label: "Niño 7–12 años", amount: 438, note: "En habitación con dos adultos" },
      { label: "Niño 4–6 años", amount: 338, note: "En habitación con dos adultos" },
      { label: "Niño 0–3 años", amount: 0, note: "Gratuito, en habitación con dos adultos", free: true },
    ],
    includes: [
      "Alojamiento 4 noches a pie de pista en el Alp Hotel Masella 3★",
      "Media pensión (desayuno y cena buffet)",
      "Forfait Masella 4 días (excepto niños 0-3 años)",
      "Actividades por las tardes para los niños, supervisadas",
      "Bajada especial de SSMM Los Reyes Magos por las pistas",
      "Guía Club Amistad y personal de apoyo en destino",
      "Atención personalizada antes, durante y después del viaje",
    ],
    supplements: [
      { label: "Clases de esquí adulto (2 h/día)", amount: 118 },
      { label: "Clases de esquí niños 6–14 años (todo el día)", amount: 218 },
      { label: "Clases de esquí niños 4–5 años (todo el día)", amount: 398 },
      { label: "Alquiler de equipo completo adulto", amount: 93 },
      { label: "Alquiler de equipo completo niño 7–17 años", amount: 80 },
      { label: "Alquiler de equipo completo niño 0–6 años", amount: 58 },
      { label: "Comida del mediodía niños con clases", amount: 49 },
      { label: "Seguro de anulación", amount: 12 },
      { label: "Ampliación de forfait a La Molina (Alp2500)", amount: 35, note: "Niños 4-6 años: 8 €" },
    ],
    notes: [
      "No incluye tasas de estancia (aproximadamente 4 €/adulto).",
      "El seguro de accidentes no está incluido — recomendamos su contratación.",
      "Viaje organizado y comercializado por Viajes Amitour · CIC.MA 841.",
    ],
    program: {
      classes: {
        intro:
          "Todas las clases están impartidas por monitores propios del Club Amistad, no por escuelas externas. Los grupos son reducidos y los niños comen con sus profesores en pista.",
        min_age: "4 años cumplidos (estricto — no se admite “casi 4 años”)",
        schedule: "Jornada completa de 10:00 a 16:00",
        groups: [
          { ages: "4–5 años", label: "Esquí Mimo", group_size: "Grupos de 3 a 5 alumnos" },
          { ages: "6–14 años", label: "Grupos por nivel", group_size: "Máximo 10 alumnos por grupo" },
        ],
        meal_note:
          "Los niños que asisten a clases comen con sus profesores en pista de 10:00 a 16:00. La comida del mediodía es obligatoria si van a clases y se contrata como suplemento (49 €).",
      },
      evening_activities: {
        schedule: "De 18:00 a 20:00, todos los días · noche del 5 con actividad de Reyes",
        description:
          "Juegos y actividades supervisadas por nuestros monitores dentro del hotel, incluidas y voluntarias. Durante la estancia se organiza la bajada especial de SSMM Los Reyes Magos por las pistas de Masella — momento estelar del viaje para los niños.",
      },
      insurance: {
        included:
          "El forfait incluye un seguro obligatorio que cubre el correcto funcionamiento del remonte, pero no cubre accidentes en pista.",
        recommended: [
          "Seguro específico de accidentes de esquí para las pistas (ofrecido por RACE).",
          "Seguro de anulación (12 € por persona, contratable al reservar o en las 48 h siguientes).",
        ],
      },
      before_travel: [
        "Videollamada informativa con el coordinador del viaje unos días antes de la salida.",
        "Circular con todos los detalles del viaje enviada por email.",
        "Alergias, dietas especiales o cualquier requisito particular: indícalos al reservar en el campo de observaciones. Tanto el hotel como los restaurantes en pista los tienen previstos.",
      ],
    },
    booking_info: {
      deposit: "Señal de 100 € por persona al confirmar la reserva.",
      payment:
        "El resto se abona en cuotas — transferencia o efectivo en oficina — antes de la fecha límite que verás en tu panel privado (aprox. 2 semanas antes del viaje).",
      confirmation:
        "Recibes la confirmación por email y puedes consultarla en tu área privada. Antes del viaje mantenemos una videollamada con el coordinador y te enviamos la circular con todos los detalles.",
      discounts: [
        "5 % de descuento a clientes que ya han viajado con Club Amistad (aplicable sobre el paquete base, no sobre los suplementos).",
        "50 % de descuento en clases para el 3er niño y siguientes cuando inscribes 3 o más niños (sobre las clases de menor valor).",
      ],
      cancellation: [
        { when: "Desde la reserva hasta 31 días antes", amount: "15 € por persona" },
        { when: "Entre 30 y 22 días antes", amount: "100 € por persona" },
        { when: "Entre 21 y 15 días antes", amount: "50 % del paquete base" },
        { when: "Entre 14 y 8 días antes", amount: "75 % de la reserva total" },
        { when: "En los últimos 7 días", amount: "100 %" },
      ],
      guarantee:
        "Garantía poca nieve: cancelación sin penalización si la estación no puede abrir un mínimo de 15 km esquiables el primer día (según el parte diario de la estación).",
    },
    faqs: [
      {
        q: "¿Cómo es exactamente la bajada de los Reyes Magos?",
        a: "SSMM Los Reyes Magos bajan por las pistas de Masella junto con nuestros monitores en un momento pensado para toda la familia — con luces, música y regalos para los niños. Es una de las escenas que más recuerdan los peques del viaje.",
      },
      {
        q: "¿Cómo funciona lo de la ampliación a La Molina?",
        a: "El forfait incluido es el de Masella (74 km). Si queréis acceder al dominio completo Alp2500 unido con La Molina — 145 km conectados — se contrata como suplemento opcional: 35 € por persona, 8 € para niños de 4 a 6 años.",
      },
      {
        q: "Es nuestra primera vez esquiando con los niños, ¿es un buen sitio para empezar?",
        a: "Es de los mejores destinos para debutar en familia. El hotel está literalmente frente a las pistas y la zona de debutantes es amplia, con poca pendiente y muy segura. Nuestros monitores llevan más de 50 años enseñando a niños que nunca antes habían pisado la nieve.",
      },
      {
        q: "Los niños de 0 a 3 años, ¿vienen gratis de verdad?",
        a: "Totalmente. No pagan alojamiento ni pensión si comparten habitación con dos adultos. Solo pagarían si quieres alquilar equipo o inscribirles a clases (mínimo 4 años cumplidos).",
      },
      {
        q: "¿Puedo pagar en cómodos plazos?",
        a: "Sí. Se abona una señal de 100 € por persona para confirmar la plaza y el resto en cuotas hasta unas dos semanas antes del viaje.",
      },
      {
        q: "¿Y si no hay nieve?",
        a: "Contamos con la garantía poca nieve: si Masella no puede abrir un mínimo de 15 km esquiables el primer día, cancelas sin penalización. Además, con La Molina el dominio suma 95 km innivados — nieve garantizada.",
      },
      {
        q: "¿Puedo cambiar la fecha del viaje o acortarlo?",
        a: "Es un viaje grupal con fechas cerradas, por lo que no se modifican. Sí puedes añadir una noche antes o después según disponibilidad y con un coste adicional. Acortar la estancia no reduce el precio del paquete.",
      },
    ],
    seo_title:
      "Viaje a la nieve Masella-La Molina · Reyes 2027 (2-6 ene) | Club Amistad",
    seo_description:
      "Plazas agotadas: esta salida está completa. Reyes 2027 en Masella-La Molina con bajada de SSMM los Reyes Magos. Alp Hotel a pie de pista, forfait 4 días y monitores propios.",
  },
  {
    slug: "cerler-escapada-enero",
    extended: true,
    external_id: 270,
    booking_url: "https://www.clubamistad.com/viajes-esqui/presupuesto/270",
    pdf_url: "/dossiers/cerler-escapada-enero.pdf",
    name: "Cerler, Escapada de Enero",
    short_name: "Cerler",
    season: "Escapada de enero",
    dates: "Del jueves 14 al domingo 17 de enero de 2027",
    dates_short: "14 – 17 ene 2027",
    duration: "4 días / 3 noches",
    ski_days: 3,
    regimen: "Media pensión — desayuno y cena buffet",
    room_distribution: "Habitaciones de 2 a 5 personas",
    price_from: 178,
    price_label: "Desde 178 €/persona",
    family_basis: "2 adultos + 2 niños",
    hero_image: "/trips/cerler-escapada-enero/hero.jpg",
    image: "/trips/cerler-escapada-enero/01.jpg",
    gallery: [
      "/trips/cerler-escapada-enero/01.jpg",
      "/trips/cerler-escapada-enero/02.jpg",
      "/trips/cerler-escapada-enero/03.jpg",
      "/trips/cerler-escapada-enero/04.jpg",
      "/trips/cerler-escapada-enero/05.jpg",
      "/trips/cerler-escapada-enero/06.jpg",
    ],
    hotel: {
      name: "Hotel Monte Alba 3★",
      subtitle: "El más cercano a las pistas · piscina · animación infantil",
      address: "1 Parcela, Calle F, 60 · 22449 Cerler · Huesca",
      phone: "974 551 136",
      highlights: [
        "El hotel más cercano a las pistas de Cerler: a apenas 200 metros del telesilla El Molino.",
        "Piscina interior y programa de animación pensado para los peques.",
        "Habitaciones familiares hasta 5 personas, con opciones de litera o sofá-cama.",
        "Un “campamento base” práctico y cómodo para pisar la nieve nada más salir del hotel.",
      ],
      extra_info: {
        description:
          "El hotel Monte Alba es el más cercano a pistas en la estación de Cerler, a unos 200 metros de las taquillas, pistas y el telesilla del Molino, al que se puede acceder descendiendo por unas escaleras que dan al parking de la estación. Cuenta con piscina y un programa de animación para los más pequeños. Un hotel práctico y cómodo en un entorno privilegiado. La mayor parte de las habitaciones del hotel son de categoría estándar, con dos camas individuales o una cama de matrimonio (número limitado y bajo petición). Algunas de esas habitaciones incorporan un sofá-cama individual o una litera. En este último caso las habitaciones pueden alojar familias completas de cuatro miembros, pero el espacio resultante es muy limitado, tanto por espacio como por capacidad de armario. Por último, algunas habitaciones estándar más espaciosas pueden llegar a alojar familias de 5 miembros, al contar con una litera y una cama supletorias.",
        services: ["Pie de pista", "Piscina", "Buffet", "Animación", "Guardaesquís"],
        amenities: ["Piscina interior", "Programa de animación infantil", "Guardaesquís propio del hotel", "Comedor buffet"],
        map_query: "Hotel Monte Alba, Calle F 60, 22449 Cerler, Huesca",
      },
    },
    resort: {
      name: "Cerler",
      subtitle: "El pueblo más alto de España · Valle de Benasque",
      highlights: [
        "80 km de pistas muy familiares, con amplias zonas para debutantes.",
        "Pistas que bajan hasta el mismo pueblo — bonito acabar el día esquiando al bar del valle.",
        "Enclave en el Valle de Benasque, rodeado de cumbres de más de 3.000 metros.",
        "389 cañones y 40 km innivados: nieve prácticamente asegurada toda la temporada.",
      ],
      stats: {
        skiable_km: 80,
        slopes_total: 69,
        slopes_breakdown: { green: 10, blue: 19, red: 26, black: 14 },
        snowmaking_km: 40,
        altitude: "1.500 – 2.630 m",
      },
      extra_info: {
        description:
          "La estación de Cerler se encuentra situada en el Pirineo oscense. El Valle de Benasque ofrece una tradición montañera justificada por su marco sin igual en España de cumbres por encima de los 3.000 metros de altitud. Cerler es el pueblo más alto de España. La estación, con 80 km de pistas, es muy familiar, con amplias zonas para debutantes y pistas hasta el mismo pueblo.",
        connections:
          "Estación con 389 cañones de innivación artificial y 40 km innivados — garantía de nieve prácticamente asegurada durante toda la temporada.",
        note: "Perfecta para familias que buscan un ambiente pirenaico tradicional, sin la masificación de otras estaciones.",
        map_query: "Estación de Esquí Cerler, 22449 Cerler, Huesca",
      },
    },
    intro:
      "Un fin de semana largo en enero para desconectar del cole y volver a la nieve: tres días esquiando en Cerler con hotel a pie de pista, monitores propios y actividades para los niños. La escapada perfecta para reencontrarse con la montaña sin necesidad de esperar al siguiente puente.",
    pain_hook:
      "Enero se hace largo entre exámenes, madrugones y frío urbano. Con esta escapada de jueves a domingo, ganas tres días de nieve sin desmontar la agenda familiar: nosotros nos ocupamos del hotel, del forfait y de las clases.",
    prices: [
      { label: "Adulto", amount: 438 },
      { label: "Niño 6–11 años", amount: 268, note: "En habitación con dos adultos" },
      { label: "Niño 3–5 años", amount: 178, note: "En habitación con dos adultos" },
      { label: "Niño 0–2 años", amount: 0, note: "En cuna, gratuito", free: true },
    ],
    includes: [
      "Alojamiento 3 noches a pie de pista en el Hotel Monte Alba 3★",
      "Media pensión (desayuno y cena buffet)",
      "Forfait Cerler 3 días (excepto niños 0-2 años)",
      "Actividades por las tardes para los niños, supervisadas",
      "Guía Club Amistad y personal de apoyo en destino",
      "Atención personalizada antes, durante y después del viaje",
    ],
    supplements: [
      { label: "Clases de esquí adulto (2 h/día)", amount: 88 },
      { label: "Clases de esquí niños 6–14 años (todo el día)", amount: 158 },
      { label: "Clases de esquí niños 4–5 años (todo el día)", amount: 298 },
      { label: "Comida del mediodía — menú plato del día", amount: 44 },
      { label: "Seguro de anulación", amount: 12 },
    ],
    notes: [
      "El precio no incluye seguros — recomendamos contratar seguro de accidentes específico de esquí.",
      "Viaje organizado y comercializado por Viajes Amitour · CIC.MA 841.",
    ],
    program: {
      classes: {
        intro:
          "Todas las clases están impartidas por monitores propios del Club Amistad, no por escuelas externas. Los grupos son reducidos y los niños comen con sus profesores en pista.",
        min_age: "4 años cumplidos (estricto — no se admite “casi 4 años”)",
        schedule: "Jornada completa de 10:00 a 16:00",
        groups: [
          { ages: "4–5 años", label: "Esquí Mimo", group_size: "Grupos de 3 a 5 alumnos" },
          { ages: "6–14 años", label: "Grupos por nivel", group_size: "Máximo 10 alumnos por grupo" },
        ],
        meal_note:
          "Los niños que asisten a clases comen con sus profesores en pista de 10:00 a 16:00. La comida del mediodía es obligatoria si van a clases y se contrata como suplemento (44 €).",
      },
      evening_activities: {
        schedule: "De 18:00 a 20:00, todos los días",
        description:
          "Juegos y actividades supervisadas por nuestros monitores dentro del hotel. Abiertas a todos los niños tengan o no clases, y sin coste adicional. La participación es voluntaria — la tarde es vuestra para hacer lo que os apetezca.",
      },
      insurance: {
        included:
          "El forfait incluye un seguro obligatorio que cubre el correcto funcionamiento del remonte, pero no cubre accidentes en pista.",
        recommended: [
          "Seguro específico de accidentes de esquí para las pistas (ofrecido por RACE).",
          "Seguro de anulación (12 € por persona, contratable al reservar o en las 48 h siguientes).",
        ],
      },
      before_travel: [
        "Videollamada informativa con el coordinador del viaje unos días antes de la salida.",
        "Circular con todos los detalles del viaje enviada por email.",
        "Alergias, dietas especiales o cualquier requisito particular: indícalos al reservar en el campo de observaciones. Tanto el hotel como los restaurantes en pista los tienen previstos.",
      ],
    },
    booking_info: {
      deposit: "Señal de 100 € por persona al confirmar la reserva.",
      payment:
        "El resto se abona en cuotas — transferencia o efectivo en oficina — antes de la fecha límite que verás en tu panel privado (aprox. 2 semanas antes del viaje).",
      confirmation:
        "Recibes la confirmación por email y puedes consultarla en tu área privada. Antes del viaje mantenemos una videollamada con el coordinador y te enviamos la circular con todos los detalles.",
      discounts: [
        "5 % de descuento a clientes que ya han viajado con Club Amistad (aplicable sobre el paquete base, no sobre los suplementos).",
        "50 % de descuento en clases para el 3er niño y siguientes cuando inscribes 3 o más niños (sobre las clases de menor valor).",
      ],
      cancellation: [
        { when: "Desde la reserva hasta 31 días antes", amount: "15 € por persona" },
        { when: "Entre 30 y 22 días antes", amount: "100 € por persona" },
        { when: "Entre 21 y 15 días antes", amount: "50 % del paquete base" },
        { when: "Entre 14 y 8 días antes", amount: "75 % de la reserva total" },
        { when: "En los últimos 7 días", amount: "100 %" },
      ],
      guarantee:
        "Garantía poca nieve: cancelación sin penalización si la estación no puede abrir un mínimo de 15 km esquiables el primer día (según el parte diario de la estación).",
    },
    faqs: [
      {
        q: "¿Merece la pena una escapada tan corta?",
        a: "Sí. Son 4 días completos (jueves a domingo) con 3 días de esquí efectivos y hotel a pie de pista. Ideal para recargar pilas en pleno enero sin necesidad de esperar a Semana Santa. Y como es fuera de puente, el ambiente en pista es mucho más relajado.",
      },
      {
        q: "Es nuestra primera vez esquiando con los niños, ¿es un buen sitio para empezar?",
        a: "Cerler es una de las mejores estaciones familiares del Pirineo. La zona debutantes es amplia y muy segura, con pistas que bajan hasta el mismo pueblo. El Monte Alba, a 200 m del telesilla, es el hotel más cómodo para no tener que cargar con material.",
      },
      {
        q: "¿Qué hacen los niños mientras yo esquío?",
        a: "Si contratáis las clases todo el día (opcional), pasan la jornada con nuestros monitores: aprenden, esquían y comen supervisados de 10 a 16h. Por las tardes hay actividades organizadas de 18:00 a 20:00 sin coste. Si preferís no meter a los peques en clases, la piscina del hotel y el programa de animación son un plan perfecto.",
      },
      {
        q: "Los niños de 0 a 2 años, ¿vienen gratis de verdad?",
        a: "Totalmente. Los bebés en cuna no pagan alojamiento ni pensión. Solo pagarían si quieres alquilar equipo o inscribirles a clases (a partir de 4 años cumplidos).",
      },
      {
        q: "¿Puedo pagar en cómodos plazos?",
        a: "Sí. Se abona una señal de 100 € por persona para confirmar la plaza y el resto en cuotas hasta unas dos semanas antes del viaje.",
      },
      {
        q: "¿Y si no hay nieve?",
        a: "Contamos con la garantía poca nieve: si Cerler no puede abrir un mínimo de 15 km esquiables el primer día, cancelas sin penalización. La estación cuenta con 389 cañones y 40 km innivados — nieve asegurada.",
      },
    ],
    seo_title:
      "Escapada a la nieve en Cerler · 14-17 ene 2027 | Club Amistad",
    seo_description:
      "Escapada a la nieve en Cerler (14-17 ene 2027). Fin de semana largo con hotel Monte Alba a pie de pista, forfait 3 días y monitores propios. Desde 178 € por niño 3–5 años; adulto 438 €.",
  },
  {
    slug: "sierra-nevada-escapada-enero",
    extended: true,
    external_id: 278,
    booking_url: "https://www.clubamistad.com/viajes-esqui/presupuesto/278",
    pdf_url: "/dossiers/sierra-nevada-escapada-enero.pdf",
    name: "Sierra Nevada, Escapada de Enero",
    short_name: "Sierra Nevada",
    season: "Escapada de enero",
    dates: "Del jueves 28 al domingo 31 de enero de 2027",
    dates_short: "28 – 31 ene 2027",
    duration: "4 días / 3 noches",
    ski_days: 3,
    regimen: "Media pensión — desayuno y cena buffet",
    room_distribution: "Habitaciones de 2 a 5 personas",
    price_from: 198,
    price_label: "Desde 198 €/persona",
    family_basis: "2 adultos + 2 niños",
    hero_image: "/trips/sierra-nevada-escapada-enero/hero.jpg",
    image: "/trips/sierra-nevada-escapada-enero/01.jpg",
    gallery: [
      "/trips/sierra-nevada-escapada-enero/01.jpg",
      "/trips/sierra-nevada-escapada-enero/02.jpg",
      "/trips/sierra-nevada-escapada-enero/03.jpg",
      "/trips/sierra-nevada-escapada-enero/04.jpg",
      "/trips/sierra-nevada-escapada-enero/05.jpg",
    ],
    hotel: {
      name: "Hotel GHM Monachil 3★",
      subtitle: "En la zona media de la estación · a 60 m del telesilla Parador",
      address: "Calle Virgen de las Nieves, s/n · 18196 Sierra Nevada · Granada",
      phone: "958 480 400",
      highlights: [
        "A 60 metros de la parada intermedia del telesilla Parador: se llega a pistas en un minuto.",
        "Pegado a la pista del Águila, con posibilidad de salir y volver esquiando (nivel avanzado).",
        "Hotel muy acogedor, construido predominantemente en madera — ambiente de montaña de verdad.",
        "Desayuno y cena tipo buffet: cada uno elige, sin negociaciones a la hora del plato.",
      ],
      extra_info: {
        description:
          "El hotel GHM Monachil se encuentra situado en la zona media de Sierra Nevada, a 60 metros de la parada intermedia del telesilla Parador y pegado a la pista del Águila, con posibilidad de llegar y salir del hotel esquiando (únicamente esquiadores avanzados, ya que la pista es roja). El hotel es muy acogedor, construido predominantemente en madera, con un salón social donde reunirse al terminar el día. Tanto el desayuno como la cena son tipo buffet. Las habitaciones son funcionales y admiten de 2 a 5 personas, con camas supletorias o litera en las familiares. Su situación permite moverse por la estación sin coche y volver al hotel a media mañana o a la hora de comer sin complicaciones.",
        services: ["Cerca de pistas", "Comidas tipo buffet", "Salón social", "Guardaesquís"],
        amenities: [
          "Construcción en madera",
          "Comedor buffet",
          "Salón social con chimenea",
          "Guardaesquís",
          "Wi-Fi en zonas comunes",
        ],
        map_query: "Hotel GHM Monachil, Sierra Nevada, 18196 Granada",
      },
    },
    resort: {
      name: "Sierra Nevada",
      subtitle: "La estación más meridional de Europa · Granada",
      highlights: [
        "Amplias zonas de debutantes con pistas anchas y suaves: ideal para el primer contacto con la nieve.",
        "Sol del sur casi garantizado — esquiar en manga corta a finales de enero no es raro aquí.",
        "Más de 110 km esquiables y cota máxima en el Veleta, a 3.300 metros.",
        "Granada a solo 31 km: apresquí, tapas y ciudad si un día apetece cambiar de plan.",
      ],
      stats: {
        skiable_km: 112,
        slopes_total: 134,
        snowmaking_km: 35,
        altitude: "2.100 – 3.300 m",
      },
      extra_info: {
        description:
          "Sierra Nevada es la estación más meridional de Europa. Su cota máxima está en el Veleta, a 3.300 metros. Es una estación muy familiar, con amplias zonas para debutantes, pistas anchas y suaves para los que comienzan y muchos kilómetros para los más avanzados. Tanto para familias como para el público más joven ofrece además una amplia oferta de apresquí, tanto en la propia estación como en la maravillosa y cercana ciudad de Granada, a tan sólo 31 km de distancia.",
        connections:
          "Estación con uno de los sistemas de innivación más potentes del sur de Europa (unos 35 km de pistas con cañones), lo que garantiza esquí en plena temporada.",
        note: "Su altitud y orientación hacen que la nieve aguante bien incluso con temperaturas suaves.",
        map_query: "Estación de Esquí Sierra Nevada, 18196 Granada",
      },
    },
    intro:
      "Tres días de esquí al sol del sur, en la estación más alta de España, con hotel a pocos metros del telesilla y Granada a media hora. Una escapada de jueves a domingo para romper el mes de enero sin desmontar la agenda familiar.",
    pain_hook:
      "Si el Pirineo os pilla lejos, Sierra Nevada es la respuesta: nieve asegurada por altitud, sol casi garantizado y todas las ventajas del Especial Familias — guía en destino, actividades de tarde para los niños y clases opcionales todo el día.",
    prices: [
      { label: "Adulto", amount: 498 },
      { label: "Niño 12–15 años", amount: 468 },
      { label: "Niño 6–11 años", amount: 298, note: "En habitación con dos adultos" },
      { label: "Niño 3–5 años", amount: 198, note: "En habitación con dos adultos" },
      { label: "Niño 0–2 años", amount: 0, note: "En cuna, gratuito", free: true },
    ],
    includes: [
      "Alojamiento 3 noches en el Hotel GHM Monachil 3★, en la estación",
      "Media pensión (desayuno y cena buffet)",
      "Forfait Sierra Nevada 3 días (excepto niños 0-2 años)",
      "Actividades por las tardes para los niños, supervisadas",
      "Guía Club Amistad y personal de apoyo en destino",
      "Atención personalizada antes, durante y después del viaje",
    ],
    supplements: [
      { label: "Clases de esquí adulto (2 h/día)", amount: 98 },
      { label: "Clases de esquí niños 6–14 años (todo el día)", amount: 168 },
      { label: "Clases de esquí niños 4–5 años (todo el día)", amount: 278 },
      { label: "Comida picnic del mediodía", amount: 57 },
      { label: "Seguro de asistencia", amount: 23 },
      { label: "Seguro de anulación", amount: 12 },
    ],
    notes: [
      "El precio del paquete no incluye ningún tipo de seguro — recomendamos contratar seguro de accidentes.",
      "Viaje organizado y comercializado por Viajes Amitour · CIC.MA 841.",
    ],
    program: {
      classes: {
        intro:
          "Todas las clases están impartidas por monitores propios del Club Amistad, no por escuelas externas. Los grupos son reducidos y los niños comen con sus profesores en pista.",
        min_age: "4 años cumplidos (estricto — no se admite “casi 4 años”)",
        schedule: "Jornada completa de 10:00 a 16:00",
        groups: [
          { ages: "4–5 años", label: "Esquí Mimo", group_size: "Grupos de 3 a 5 alumnos" },
          { ages: "6–14 años", label: "Grupos por nivel", group_size: "Máximo 10 alumnos por grupo" },
        ],
        meal_note:
          "Los niños que asisten a clases comen con sus profesores en pista de 10:00 a 16:00. La comida del mediodía es obligatoria si van a clases y se contrata como suplemento (picnic, 57 €).",
      },
      evening_activities: {
        schedule: "De 18:00 a 20:00, todos los días",
        description:
          "Juegos y actividades supervisadas por nuestros monitores dentro del hotel. Abiertas a todos los niños tengan o no clases, y sin coste adicional. La participación es voluntaria — la tarde es vuestra para hacer lo que os apetezca.",
      },
      insurance: {
        included:
          "El forfait incluye un seguro obligatorio que cubre el correcto funcionamiento del remonte, pero no cubre accidentes en pista.",
        recommended: [
          "Seguro de asistencia en viaje (23 € por persona).",
          "Seguro de anulación (12 € por persona, contratable al reservar o en las 48 h siguientes).",
        ],
      },
      before_travel: [
        "Videollamada informativa con el coordinador del viaje unos días antes de la salida.",
        "Circular con todos los detalles del viaje enviada por email.",
        "Alergias, dietas especiales o cualquier requisito particular: indícalos al reservar en el campo de observaciones. Tanto el hotel como los restaurantes en pista los tienen previstos.",
      ],
    },
    booking_info: {
      deposit: "Señal de 100 € por persona al confirmar la reserva.",
      payment:
        "El resto se abona en cuotas — transferencia o efectivo en oficina — antes de la fecha límite que verás en tu panel privado (aprox. 2 semanas antes del viaje).",
      confirmation:
        "Recibes la confirmación por email y puedes consultarla en tu área privada. Antes del viaje mantenemos una videollamada con el coordinador y te enviamos la circular con todos los detalles.",
      discounts: [
        "5 % de descuento a clientes que ya han viajado con Club Amistad (aplicable sobre el paquete base, no sobre los suplementos).",
        "50 % de descuento en clases para el 3er niño y siguientes cuando inscribes 3 o más niños (sobre las clases de menor valor).",
      ],
      cancellation: [
        { when: "Desde la reserva hasta 31 días antes", amount: "15 € por persona" },
        { when: "Entre 30 y 22 días antes", amount: "100 € por persona" },
        { when: "Entre 21 y 15 días antes", amount: "50 % del paquete base" },
        { when: "Entre 14 y 8 días antes", amount: "75 % de la reserva total" },
        { when: "En los últimos 7 días", amount: "100 %" },
      ],
      guarantee:
        "Garantía poca nieve: cancelación sin penalización si la estación no puede abrir un mínimo de 15 km esquiables el primer día (según el parte diario de la estación).",
    },
    faqs: [
      {
        q: "¿Sierra Nevada es buena opción si vamos desde Madrid?",
        a: "Sí. Está a unas 4 h 30 min por autovía y el hotel está dentro de la estación, así que una vez llegáis no necesitáis mover el coche en todo el fin de semana. Además, su altitud (base a 2.100 m) hace que la nieve aguante mucho mejor que en estaciones más bajas.",
      },
      {
        q: "Es nuestra primera vez esquiando con los niños, ¿es un buen sitio para empezar?",
        a: "Es una de las mejores estaciones de España para debutar: las zonas de principiantes son amplias, con pistas anchas, suaves y muy soleadas. Nuestros monitores llevan más de 50 años enseñando a niños que nunca antes habían pisado la nieve.",
      },
      {
        q: "¿Qué hacen los niños mientras yo esquío?",
        a: "Si contratáis las clases todo el día (opcional), pasan la jornada con nuestros monitores: aprenden, esquían y comen supervisados de 10 a 16h. Por las tardes hay actividades organizadas en el hotel de 18:00 a 20:00, sin coste y abiertas a todos los niños.",
      },
      {
        q: "Los niños de 0 a 2 años, ¿vienen gratis de verdad?",
        a: "Totalmente. Los bebés en cuna no pagan alojamiento ni pensión si comparten habitación con dos adultos. Solo pagarían equipo o clases (a partir de 4 años cumplidos).",
      },
      {
        q: "¿Se puede aprovechar para visitar Granada?",
        a: "Granada está a solo 31 km, unos 40 minutos en coche. Muchas familias bajan una tarde a pasear por el centro o cenar de tapas. También podéis alargar la estancia una noche antes o después según disponibilidad.",
      },
      {
        q: "¿Puedo pagar en cómodos plazos?",
        a: "Sí. Se abona una señal de 100 € por persona para confirmar la plaza y el resto en cuotas hasta unas dos semanas antes del viaje.",
      },
    ],
    seo_title:
      "Escapada a la nieve en Sierra Nevada · 28-31 ene 2027 | Club Amistad",
    seo_description:
      "Escapada familiar a Sierra Nevada (28-31 ene 2027). Hotel GHM Monachil en la estación, forfait 3 días y monitores propios. Desde 198 € por niño 3–5 años; adulto 498 €.",
  },
  {
    slug: "sierra-nevada-escapada-febrero",
    extended: true,
    external_id: 279,
    booking_url: "https://www.clubamistad.com/viajes-esqui/presupuesto/279",
    pdf_url: "/dossiers/sierra-nevada-escapada-febrero.pdf",
    name: "Sierra Nevada, Escapada de Febrero",
    short_name: "Sierra Nevada",
    season: "Escapada de febrero",
    dates: "Del jueves 25 al domingo 28 de febrero de 2027",
    dates_short: "25 – 28 feb 2027",
    duration: "4 días / 3 noches",
    ski_days: 3,
    regimen: "Media pensión — desayuno y cena buffet",
    room_distribution: "Habitaciones de 2 a 5 personas",
    price_from: 218,
    price_label: "Desde 218 €/persona",
    family_basis: "2 adultos + 2 niños",
    hero_image: "/trips/sierra-nevada-escapada-febrero/hero.jpg",
    image: "/trips/sierra-nevada-escapada-febrero/01.jpg",
    gallery: [
      "/trips/sierra-nevada-escapada-febrero/01.jpg",
      "/trips/sierra-nevada-escapada-febrero/02.jpg",
      "/trips/sierra-nevada-escapada-febrero/03.jpg",
      "/trips/sierra-nevada-escapada-febrero/04.jpg",
      "/trips/sierra-nevada-escapada-febrero/05.jpg",
    ],
    hotel: {
      name: "Hotel GHM Monachil 3★",
      subtitle: "En la zona media de la estación · a 60 m del telesilla Parador",
      address: "Calle Virgen de las Nieves, s/n · 18196 Sierra Nevada · Granada",
      phone: "958 480 400",
      highlights: [
        "A 60 metros de la parada intermedia del telesilla Parador: se llega a pistas en un minuto.",
        "Pegado a la pista del Águila, con posibilidad de salir y volver esquiando (nivel avanzado).",
        "Hotel muy acogedor, construido predominantemente en madera — ambiente de montaña de verdad.",
        "Desayuno y cena tipo buffet: cada uno elige, sin negociaciones a la hora del plato.",
      ],
      extra_info: {
        description:
          "El hotel GHM Monachil se encuentra situado en la zona media de Sierra Nevada, a 60 metros de la parada intermedia del telesilla Parador y pegado a la pista del Águila, con posibilidad de llegar y salir del hotel esquiando (únicamente esquiadores avanzados, ya que la pista es roja). El hotel es muy acogedor, construido predominantemente en madera, con un salón social donde reunirse al terminar el día. Tanto el desayuno como la cena son tipo buffet. Las habitaciones son funcionales y admiten de 2 a 5 personas, con camas supletorias o litera en las familiares. Su situación permite moverse por la estación sin coche y volver al hotel a media mañana o a la hora de comer sin complicaciones.",
        services: ["Cerca de pistas", "Comidas tipo buffet", "Salón social", "Guardaesquís"],
        amenities: [
          "Construcción en madera",
          "Comedor buffet",
          "Salón social con chimenea",
          "Guardaesquís",
          "Wi-Fi en zonas comunes",
        ],
        map_query: "Hotel GHM Monachil, Sierra Nevada, 18196 Granada",
      },
    },
    resort: {
      name: "Sierra Nevada",
      subtitle: "La estación más meridional de Europa · Granada",
      highlights: [
        "Finales de febrero: mejor base de nieve de toda la temporada y días ya largos y soleados.",
        "Amplias zonas de debutantes con pistas anchas y suaves para los que empiezan.",
        "Más de 110 km esquiables y cota máxima en el Veleta, a 3.300 metros.",
        "Granada a solo 31 km: apresquí, tapas y ciudad si un día apetece cambiar de plan.",
      ],
      stats: {
        skiable_km: 112,
        slopes_total: 134,
        snowmaking_km: 35,
        altitude: "2.100 – 3.300 m",
      },
      extra_info: {
        description:
          "Sierra Nevada es la estación más meridional de Europa. Su cota máxima está en el Veleta, a 3.300 metros. Es una estación muy familiar, con amplias zonas para debutantes, pistas anchas y suaves para los que comienzan y muchos kilómetros para los más avanzados. Tanto para familias como para el público más joven ofrece además una amplia oferta de apresquí, tanto en la propia estación como en la maravillosa y cercana ciudad de Granada, a tan sólo 31 km de distancia.",
        connections:
          "Estación con uno de los sistemas de innivación más potentes del sur de Europa (unos 35 km de pistas con cañones), lo que garantiza esquí en plena temporada.",
        note: "Finales de febrero suele ser el momento con mejor espesor de nieve acumulado de toda la temporada.",
        map_query: "Estación de Esquí Sierra Nevada, 18196 Granada",
      },
    },
    intro:
      "Jueves a domingo a finales de febrero, cuando Sierra Nevada tiene la mejor nieve de la temporada y los días ya son largos. Hotel dentro de la estación, forfait de 3 días y todo el programa Especial Familias incluido.",
    pain_hook:
      "Febrero es el mes con mejores condiciones de nieve del año, y también el más largo sin vacaciones escolares. Esta escapada os da tres días de montaña sin pedir permiso a todo el calendario: nosotros nos ocupamos del hotel, del forfait y de las clases.",
    prices: [
      { label: "Adulto", amount: 548 },
      { label: "Niño 12–15 años", amount: 518 },
      { label: "Niño 6–11 años", amount: 318, note: "En habitación con dos adultos" },
      { label: "Niño 3–5 años", amount: 218, note: "En habitación con dos adultos" },
      { label: "Niño 0–2 años", amount: 0, note: "En cuna, gratuito", free: true },
    ],
    includes: [
      "Alojamiento 3 noches en el Hotel GHM Monachil 3★, en la estación",
      "Media pensión (desayuno y cena buffet)",
      "Forfait Sierra Nevada 3 días (excepto niños 0-2 años)",
      "Actividades por las tardes para los niños, supervisadas",
      "Guía Club Amistad y personal de apoyo en destino",
      "Atención personalizada antes, durante y después del viaje",
    ],
    supplements: [
      { label: "Clases de esquí adulto (2 h/día)", amount: 98 },
      { label: "Clases de esquí niños 6–14 años (todo el día)", amount: 178 },
      { label: "Clases de esquí niños 4–5 años (todo el día)", amount: 298 },
      { label: "Comida picnic del mediodía", amount: 63 },
      { label: "Seguro de asistencia", amount: 23 },
      { label: "Seguro de anulación", amount: 12 },
    ],
    notes: [
      "El precio del paquete no incluye ningún tipo de seguro — recomendamos contratar seguro de accidentes.",
      "Viaje organizado y comercializado por Viajes Amitour · CIC.MA 841.",
    ],
    program: {
      classes: {
        intro:
          "Todas las clases están impartidas por monitores propios del Club Amistad, no por escuelas externas. Los grupos son reducidos y los niños comen con sus profesores en pista.",
        min_age: "4 años cumplidos (estricto — no se admite “casi 4 años”)",
        schedule: "Jornada completa de 10:00 a 16:00",
        groups: [
          { ages: "4–5 años", label: "Esquí Mimo", group_size: "Grupos de 3 a 5 alumnos" },
          { ages: "6–14 años", label: "Grupos por nivel", group_size: "Máximo 10 alumnos por grupo" },
        ],
        meal_note:
          "Los niños que asisten a clases comen con sus profesores en pista de 10:00 a 16:00. La comida del mediodía es obligatoria si van a clases y se contrata como suplemento (picnic, 63 €).",
      },
      evening_activities: {
        schedule: "De 18:00 a 20:00, todos los días",
        description:
          "Juegos y actividades supervisadas por nuestros monitores dentro del hotel. Abiertas a todos los niños tengan o no clases, y sin coste adicional. La participación es voluntaria — la tarde es vuestra para hacer lo que os apetezca.",
      },
      insurance: {
        included:
          "El forfait incluye un seguro obligatorio que cubre el correcto funcionamiento del remonte, pero no cubre accidentes en pista.",
        recommended: [
          "Seguro de asistencia en viaje (23 € por persona).",
          "Seguro de anulación (12 € por persona, contratable al reservar o en las 48 h siguientes).",
        ],
      },
      before_travel: [
        "Videollamada informativa con el coordinador del viaje unos días antes de la salida.",
        "Circular con todos los detalles del viaje enviada por email.",
        "Alergias, dietas especiales o cualquier requisito particular: indícalos al reservar en el campo de observaciones. Tanto el hotel como los restaurantes en pista los tienen previstos.",
      ],
    },
    booking_info: {
      deposit: "Señal de 100 € por persona al confirmar la reserva.",
      payment:
        "El resto se abona en cuotas — transferencia o efectivo en oficina — antes de la fecha límite que verás en tu panel privado (aprox. 2 semanas antes del viaje).",
      confirmation:
        "Recibes la confirmación por email y puedes consultarla en tu área privada. Antes del viaje mantenemos una videollamada con el coordinador y te enviamos la circular con todos los detalles.",
      discounts: [
        "5 % de descuento a clientes que ya han viajado con Club Amistad (aplicable sobre el paquete base, no sobre los suplementos).",
        "50 % de descuento en clases para el 3er niño y siguientes cuando inscribes 3 o más niños (sobre las clases de menor valor).",
      ],
      cancellation: [
        { when: "Desde la reserva hasta 31 días antes", amount: "15 € por persona" },
        { when: "Entre 30 y 22 días antes", amount: "100 € por persona" },
        { when: "Entre 21 y 15 días antes", amount: "50 % del paquete base" },
        { when: "Entre 14 y 8 días antes", amount: "75 % de la reserva total" },
        { when: "En los últimos 7 días", amount: "100 %" },
      ],
      guarantee:
        "Garantía poca nieve: cancelación sin penalización si la estación no puede abrir un mínimo de 15 km esquiables el primer día (según el parte diario de la estación).",
    },
    faqs: [
      {
        q: "¿Cómo suele estar la nieve en Sierra Nevada a finales de febrero?",
        a: "Es el mejor momento de la temporada: la base de nieve está en su punto máximo tras todo el invierno y los días ya son más largos y soleados. Además, la estación cuenta con unos 35 km innivados como refuerzo.",
      },
      {
        q: "¿Sierra Nevada es buena opción si vamos desde Madrid?",
        a: "Sí. Está a unas 4 h 30 min por autovía y el hotel está dentro de la estación, así que una vez llegáis no necesitáis mover el coche en todo el fin de semana.",
      },
      {
        q: "Es nuestra primera vez esquiando con los niños, ¿es un buen sitio para empezar?",
        a: "Es una de las mejores estaciones de España para debutar: las zonas de principiantes son amplias, con pistas anchas, suaves y muy soleadas. Nuestros monitores llevan más de 50 años enseñando a niños que nunca antes habían pisado la nieve.",
      },
      {
        q: "¿Qué hacen los niños mientras yo esquío?",
        a: "Si contratáis las clases todo el día (opcional), pasan la jornada con nuestros monitores: aprenden, esquían y comen supervisados de 10 a 16h. Por las tardes hay actividades organizadas en el hotel de 18:00 a 20:00, sin coste y abiertas a todos los niños.",
      },
      {
        q: "¿Se puede aprovechar para visitar Granada?",
        a: "Granada está a solo 31 km, unos 40 minutos en coche. Muchas familias bajan una tarde a pasear por el centro o cenar de tapas. También podéis alargar la estancia una noche antes o después según disponibilidad.",
      },
      {
        q: "¿Puedo pagar en cómodos plazos?",
        a: "Sí. Se abona una señal de 100 € por persona para confirmar la plaza y el resto en cuotas hasta unas dos semanas antes del viaje.",
      },
    ],
    seo_title:
      "Escapada a la nieve en Sierra Nevada · 25-28 feb 2027 | Club Amistad",
    seo_description:
      "Escapada familiar a Sierra Nevada (25-28 feb 2027). Hotel GHM Monachil en la estación, forfait 3 días y monitores propios. Desde 218 € por niño 3–5 años; adulto 548 €.",
  },

  {
    slug: "cerler-escapada-marzo",
    extended: true,
    sold_out: true,
    external_id: 271,
    booking_url: "https://www.clubamistad.com/viajes-esqui/presupuesto/271",
    pdf_url: "/dossiers/cerler-escapada-marzo.pdf",
    name: "Cerler, Escapada de Marzo",
    short_name: "Cerler",
    season: "Escapada de marzo",
    dates: "Del jueves 4 al domingo 7 de marzo de 2027",
    dates_short: "4 – 7 mar 2027",
    duration: "4 días / 3 noches",
    ski_days: 3,
    regimen: "Media pensión — desayuno y cena buffet",
    room_distribution: "Habitaciones de 2 a 5 personas",
    price_from: 178,
    price_label: "Desde 178 €/persona",
    family_basis: "2 adultos + 2 niños",
    hero_image: "/trips/cerler-escapada-marzo/hero.jpg",
    image: "/trips/cerler-escapada-marzo/01.jpg",
    gallery: [
      "/trips/cerler-escapada-marzo/01.jpg",
      "/trips/cerler-escapada-marzo/02.jpg",
      "/trips/cerler-escapada-marzo/03.jpg",
      "/trips/cerler-escapada-marzo/04.jpg",
      "/trips/cerler-escapada-marzo/05.jpg",
      "/trips/cerler-escapada-marzo/06.jpg",
    ],
    hotel: {
      name: "Hotel Monte Alba 3★",
      subtitle: "El más cercano a las pistas · piscina · animación infantil",
      address: "1 Parcela, Calle F, 60 · 22449 Cerler · Huesca",
      phone: "974 551 136",
      highlights: [
        "El hotel más cercano a las pistas de Cerler: a apenas 200 metros del telesilla El Molino.",
        "Piscina interior y programa de animación pensado para los peques.",
        "Habitaciones familiares hasta 5 personas, con opciones de litera o sofá-cama.",
        "Un “campamento base” práctico y cómodo para pisar la nieve nada más salir del hotel.",
      ],
      extra_info: {
        description:
          "El hotel Monte Alba es el más cercano a pistas en la estación de Cerler, a unos 200 metros de las taquillas, pistas y el telesilla del Molino, al que se puede acceder descendiendo por unas escaleras que dan al parking de la estación. Cuenta con piscina y un programa de animación para los más pequeños. Un hotel práctico y cómodo en un entorno privilegiado. La mayor parte de las habitaciones del hotel son de categoría estándar, con dos camas individuales o una cama de matrimonio (número limitado y bajo petición). Algunas de esas habitaciones incorporan un sofá-cama individual o una litera. En este último caso las habitaciones pueden alojar familias completas de cuatro miembros, pero el espacio resultante es muy limitado, tanto por espacio como por capacidad de armario. Por último, algunas habitaciones estándar más espaciosas pueden llegar a alojar familias de 5 miembros, al contar con una litera y una cama supletorias.",
        services: ["Pie de pista", "Piscina", "Buffet", "Animación", "Guardaesquís"],
        amenities: ["Piscina interior", "Programa de animación infantil", "Guardaesquís propio del hotel", "Comedor buffet"],
        map_query: "Hotel Monte Alba, Calle F 60, 22449 Cerler, Huesca",
      },
    },
    resort: {
      name: "Cerler",
      subtitle: "El pueblo más alto de España · Valle de Benasque",
      highlights: [
        "80 km de pistas muy familiares, con amplias zonas para debutantes.",
        "Pistas que bajan hasta el mismo pueblo — bonito acabar el día esquiando al bar del valle.",
        "Enclave en el Valle de Benasque, rodeado de cumbres de más de 3.000 metros.",
        "389 cañones y 40 km innivados: nieve prácticamente asegurada toda la temporada.",
      ],
      stats: {
        skiable_km: 80,
        slopes_total: 69,
        slopes_breakdown: { green: 10, blue: 19, red: 26, black: 14 },
        snowmaking_km: 40,
        altitude: "1.500 – 2.630 m",
      },
      extra_info: {
        description:
          "La estación de Cerler se encuentra situada en el Pirineo oscense. El Valle de Benasque ofrece una tradición montañera justificada por su marco sin igual en España de cumbres por encima de los 3.000 metros de altitud. Cerler es el pueblo más alto de España. La estación, con 80 km de pistas, es muy familiar, con amplias zonas para debutantes y pistas hasta el mismo pueblo.",
        connections:
          "Estación con 389 cañones de innivación artificial y 40 km innivados — garantía de nieve prácticamente asegurada durante toda la temporada.",
        note: "En marzo, con más horas de luz y sol templado del Pirineo, esquiar en Cerler se vive con un plus de disfrute.",
        map_query: "Estación de Esquí Cerler, 22449 Cerler, Huesca",
      },
    },
    intro:
      "Escapada larga de marzo en el Pirineo aragonés: 4 días y 3 noches en Cerler con hotel a pie de pista, sol de primavera y ambiente familiar. La forma perfecta de despedir la temporada de esquí antes de que llegue el buen tiempo.",
    pain_hook:
      "En marzo apetece cambiar de aires antes de encarar la recta final del curso. Con esta escapada te llevas a la familia a la nieve sin tener que organizar nada: hotel, forfait, monitores y clases — todo cerrado y con precio claro.",
    prices: [
      { label: "Adulto", amount: 438 },
      { label: "Niño 6–11 años", amount: 268, note: "En habitación con dos adultos" },
      { label: "Niño 3–5 años", amount: 178, note: "En habitación con dos adultos" },
      { label: "Niño 0–2 años", amount: 0, note: "En cuna, gratuito", free: true },
    ],
    includes: [
      "Alojamiento 3 noches a pie de pista en el Hotel Monte Alba 3★",
      "Media pensión (desayuno y cena buffet)",
      "Forfait Cerler 3 días (excepto niños 0-2 años)",
      "Actividades por las tardes para los niños, supervisadas",
      "Guía Club Amistad y personal de apoyo en destino",
      "Atención personalizada antes, durante y después del viaje",
    ],
    supplements: [
      { label: "Clases de esquí adulto (2 h/día)", amount: 88 },
      { label: "Clases de esquí niños 6–14 años (todo el día)", amount: 158 },
      { label: "Clases de esquí niños 4–5 años (todo el día)", amount: 298 },
      { label: "Comida del mediodía — menú plato del día", amount: 44 },
      { label: "Seguro de anulación", amount: 12 },
    ],
    notes: [
      "El precio no incluye seguros — recomendamos contratar seguro de accidentes específico de esquí.",
      "Viaje organizado y comercializado por Viajes Amitour · CIC.MA 841.",
    ],
    program: {
      classes: {
        intro:
          "Todas las clases están impartidas por monitores propios del Club Amistad, no por escuelas externas. Los grupos son reducidos y los niños comen con sus profesores en pista.",
        min_age: "4 años cumplidos (estricto — no se admite “casi 4 años”)",
        schedule: "Jornada completa de 10:00 a 16:00",
        groups: [
          { ages: "4–5 años", label: "Esquí Mimo", group_size: "Grupos de 3 a 5 alumnos" },
          { ages: "6–14 años", label: "Grupos por nivel", group_size: "Máximo 10 alumnos por grupo" },
        ],
        meal_note:
          "Los niños que asisten a clases comen con sus profesores en pista de 10:00 a 16:00. La comida del mediodía es obligatoria si van a clases y se contrata como suplemento (44 €).",
      },
      evening_activities: {
        schedule: "De 18:00 a 20:00, todos los días",
        description:
          "Juegos y actividades supervisadas por nuestros monitores dentro del hotel. Abiertas a todos los niños tengan o no clases, y sin coste adicional. La participación es voluntaria — la tarde es vuestra para hacer lo que os apetezca.",
      },
      insurance: {
        included:
          "El forfait incluye un seguro obligatorio que cubre el correcto funcionamiento del remonte, pero no cubre accidentes en pista.",
        recommended: [
          "Seguro específico de accidentes de esquí para las pistas (ofrecido por RACE).",
          "Seguro de anulación (12 € por persona, contratable al reservar o en las 48 h siguientes).",
        ],
      },
      before_travel: [
        "Videollamada informativa con el coordinador del viaje unos días antes de la salida.",
        "Circular con todos los detalles del viaje enviada por email.",
        "Alergias, dietas especiales o cualquier requisito particular: indícalos al reservar en el campo de observaciones. Tanto el hotel como los restaurantes en pista los tienen previstos.",
      ],
    },
    booking_info: {
      deposit: "Señal de 100 € por persona al confirmar la reserva.",
      payment:
        "El resto se abona en cuotas — transferencia o efectivo en oficina — antes de la fecha límite que verás en tu panel privado (aprox. 2 semanas antes del viaje).",
      confirmation:
        "Recibes la confirmación por email y puedes consultarla en tu área privada. Antes del viaje mantenemos una videollamada con el coordinador y te enviamos la circular con todos los detalles.",
      discounts: [
        "5 % de descuento a clientes que ya han viajado con Club Amistad (aplicable sobre el paquete base, no sobre los suplementos).",
        "50 % de descuento en clases para el 3er niño y siguientes cuando inscribes 3 o más niños (sobre las clases de menor valor).",
      ],
      cancellation: [
        { when: "Desde la reserva hasta 31 días antes", amount: "15 € por persona" },
        { when: "Entre 30 y 22 días antes", amount: "100 € por persona" },
        { when: "Entre 21 y 15 días antes", amount: "50 % del paquete base" },
        { when: "Entre 14 y 8 días antes", amount: "75 % de la reserva total" },
        { when: "En los últimos 7 días", amount: "100 %" },
      ],
      guarantee:
        "Garantía poca nieve: cancelación sin penalización si la estación no puede abrir un mínimo de 15 km esquiables el primer día (según el parte diario de la estación).",
    },
    faqs: [
      {
        q: "¿Cómo suele estar la nieve en Cerler a principios de marzo?",
        a: "Marzo es de los mejores meses en el Pirineo: la base de nieve es sólida por la temporada acumulada, hay más horas de luz y el sol es más agradable. Cerler cuenta con 389 cañones y 40 km innivados como refuerzo por si acaso.",
      },
      {
        q: "Es nuestra primera vez esquiando con los niños, ¿es un buen sitio para empezar?",
        a: "Cerler es una de las mejores estaciones familiares del Pirineo. La zona debutantes es amplia y muy segura, con pistas que bajan hasta el mismo pueblo. El Monte Alba, a 200 m del telesilla, es el hotel más cómodo para no tener que cargar con material.",
      },
      {
        q: "¿Qué hacen los niños mientras yo esquío?",
        a: "Si contratáis las clases todo el día (opcional), pasan la jornada con nuestros monitores: aprenden, esquían y comen supervisados de 10 a 16h. Por las tardes hay actividades organizadas de 18:00 a 20:00 sin coste. Si preferís no meter a los peques en clases, la piscina del hotel y el programa de animación son un plan perfecto.",
      },
      {
        q: "Los niños de 0 a 2 años, ¿vienen gratis de verdad?",
        a: "Totalmente. Los bebés en cuna no pagan alojamiento ni pensión. Solo pagarían si quieres alquilar equipo o inscribirles a clases (a partir de 4 años cumplidos).",
      },
      {
        q: "¿Puedo pagar en cómodos plazos?",
        a: "Sí. Se abona una señal de 100 € por persona para confirmar la plaza y el resto en cuotas hasta unas dos semanas antes del viaje.",
      },
      {
        q: "¿Y si no hay nieve?",
        a: "Contamos con la garantía poca nieve: si Cerler no puede abrir un mínimo de 15 km esquiables el primer día, cancelas sin penalización. La estación cuenta con 389 cañones y 40 km innivados — nieve asegurada.",
      },
    ],
    seo_title:
      "Escapada a la nieve en Cerler · 4-7 mar 2027 | Club Amistad",
    seo_description:
      "Plazas agotadas: esta salida está completa. Escapada a la nieve en Cerler (4-7 mar 2027). Sol de primavera y nieve de calidad, hotel a pie de pista y forfait 3 días.",
  },
  {
    slug: "cerler-semana-santa",
    extended: true,
    external_id: 274,
    booking_url: "https://www.clubamistad.com/viajes-esqui/presupuesto/274",
    pdf_url: "/dossiers/cerler-semana-santa.pdf",
    name: "Cerler, Semana Santa",
    short_name: "Cerler",
    season: "Semana Santa",
    dates: "Del viernes 19 al martes 23 de marzo de 2027",
    dates_short: "19 – 23 mar 2027",
    duration: "5 días / 4 noches",
    ski_days: 4,
    regimen: "Media pensión — desayuno y cena buffet",
    room_distribution: "Habitaciones de 2 a 4 personas",
    price_from: 213,
    price_label: "Desde 213 €/persona",
    family_basis: "2 adultos + 2 niños",
    hero_image: "/trips/cerler-semana-santa/hero.jpg",
    image: "/trips/cerler-semana-santa/01.jpg",
    gallery: [
      "/trips/cerler-semana-santa/01.jpg",
      "/trips/cerler-semana-santa/02.jpg",
      "/trips/cerler-semana-santa/03.jpg",
      "/trips/cerler-semana-santa/04.jpg",
      "/trips/cerler-semana-santa/05.jpg",
      "/trips/cerler-semana-santa/06.jpg",
    ],
    hotel: {
      name: "Hotel Monte Alba 3★",
      subtitle: "El más cercano a las pistas · piscina · animación infantil",
      address: "1 Parcela, Calle F, 60 · 22449 Cerler · Huesca",
      phone: "974 551 136",
      highlights: [
        "El hotel más cercano a las pistas de Cerler: a apenas 200 metros del telesilla El Molino.",
        "Piscina interior y programa de animación pensado para los peques.",
        "Habitaciones familiares hasta 4 personas, con opciones de litera o sofá-cama.",
        "Un “campamento base” práctico y cómodo para pisar la nieve nada más salir del hotel.",
      ],
      extra_info: {
        description:
          "El hotel Monte Alba es el más cercano a pistas en la estación de Cerler, a unos 200 metros de las taquillas, pistas y el telesilla del Molino, al que se puede acceder descendiendo por unas escaleras que dan al parking de la estación. Cuenta con piscina y un programa de animación para los más pequeños. Un hotel práctico y cómodo en un entorno privilegiado. La mayor parte de las habitaciones del hotel son de categoría estándar, con dos camas individuales o una cama de matrimonio (número limitado y bajo petición). Algunas de esas habitaciones incorporan un sofá-cama individual o una litera. En este último caso las habitaciones pueden alojar familias completas de cuatro miembros, pero el espacio resultante es muy limitado, tanto por espacio como por capacidad de armario.",
        services: ["Pie de pista", "Piscina", "Buffet", "Animación", "Guardaesquís"],
        amenities: ["Piscina interior", "Programa de animación infantil", "Guardaesquís propio del hotel", "Comedor buffet"],
        map_query: "Hotel Monte Alba, Calle F 60, 22449 Cerler, Huesca",
      },
    },
    resort: {
      name: "Cerler",
      subtitle: "El pueblo más alto de España · Valle de Benasque",
      highlights: [
        "80 km de pistas muy familiares, con amplias zonas para debutantes.",
        "Pistas que bajan hasta el mismo pueblo — bonito acabar el día esquiando al bar del valle.",
        "Enclave en el Valle de Benasque, rodeado de cumbres de más de 3.000 metros.",
        "389 cañones y 40 km innivados: nieve prácticamente asegurada toda la temporada.",
      ],
      stats: {
        skiable_km: 80,
        slopes_total: 69,
        slopes_breakdown: { green: 10, blue: 19, red: 26, black: 14 },
        snowmaking_km: 40,
        altitude: "1.500 – 2.630 m",
      },
      extra_info: {
        description:
          "La estación de Cerler se encuentra situada en el Pirineo oscense. El Valle de Benasque ofrece una tradición montañera justificada por su marco sin igual en España de cumbres por encima de los 3.000 metros de altitud. Cerler es el pueblo más alto de España. La estación, con 80 km de pistas, es muy familiar, con amplias zonas para debutantes y pistas hasta el mismo pueblo.",
        connections:
          "Estación con 389 cañones de innivación artificial y 40 km innivados — garantía de nieve prácticamente asegurada durante toda la temporada.",
        note: "Semana Santa es de los mejores momentos para esquiar en Cerler: nieve primavera, buen tiempo y ambiente familiar.",
        map_query: "Estación de Esquí Cerler, 22449 Cerler, Huesca",
      },
    },
    intro:
      "Semana Santa en el Pirineo aragonés: cinco días para desconectar en familia con Cerler a pie de pista, sol de primavera y todos los servicios pensados para que los niños se lo pasen en grande mientras los adultos disfrutan de la montaña sin agobios.",
    pain_hook:
      "Semana Santa suele ser sinónimo de embotellamientos, apuros de última hora y precios que se disparan. Aquí llegas con todo cerrado — hotel a pie de pista, forfait 4 días, monitores propios y actividades para los peques — y solo te preocupas de bajar bien las pistas.",
    prices: [
      { label: "Adulto", amount: 638 },
      { label: "Niño 6–11 años", amount: 358, note: "En habitación con dos adultos" },
      { label: "Niño 4–5 años", amount: 268, note: "En habitación con dos adultos" },
      { label: "Niño 2–3 años", amount: 213, note: "En habitación con dos adultos" },
      { label: "Niño 0–1 años", amount: 0, note: "En cuna, gratuito", free: true },
    ],
    includes: [
      "Alojamiento 4 noches a pie de pista en el Hotel Monte Alba 3★",
      "Media pensión (desayuno y cena buffet)",
      "Forfait Cerler 4 días (excepto niños 0-3 años)",
      "Actividades por las tardes para los niños, supervisadas",
      "Guía Club Amistad y personal de apoyo 24 h en destino",
      "Atención personalizada antes, durante y después del viaje",
    ],
    supplements: [
      { label: "Clases de esquí adulto (2 h/día)", amount: 118 },
      { label: "Clases de esquí niños 6–14 años (todo el día)", amount: 218 },
      { label: "Clases de esquí niños 4–5 años (todo el día)", amount: 398 },
      { label: "Alquiler de equipo completo adulto (sin casco)", amount: 79 },
      { label: "Alquiler de equipo completo niño (con casco)", amount: 79 },
      { label: "Comida del mediodía — menú plato del día", amount: 59 },
      { label: "Seguro de anulación", amount: 12 },
    ],
    notes: [
      "El precio no incluye seguros — recomendamos contratar seguro de accidentes específico de esquí.",
      "Viaje organizado y comercializado por Viajes Amitour · CIC.MA 841.",
    ],
    program: {
      classes: {
        intro:
          "Todas las clases están impartidas por monitores propios del Club Amistad, no por escuelas externas. Los grupos son reducidos y los niños comen con sus profesores en pista.",
        min_age: "4 años cumplidos (estricto — no se admite “casi 4 años”)",
        schedule: "Jornada completa de 10:00 a 16:00",
        groups: [
          { ages: "4–5 años", label: "Esquí Mimo", group_size: "Grupos de 3 a 5 alumnos" },
          { ages: "6–14 años", label: "Grupos por nivel", group_size: "Máximo 10 alumnos por grupo" },
        ],
        meal_note:
          "Los niños que asisten a clases comen con sus profesores en pista de 10:00 a 16:00. La comida del mediodía es obligatoria si van a clases y se contrata como suplemento (59 €).",
      },
      evening_activities: {
        schedule: "De 18:00 a 20:00, todos los días",
        description:
          "Juegos y actividades supervisadas por nuestros monitores dentro del hotel. Abiertas a todos los niños tengan o no clases, y sin coste adicional. La participación es voluntaria — la tarde es vuestra para hacer lo que os apetezca.",
      },
      insurance: {
        included:
          "El forfait incluye un seguro obligatorio que cubre el correcto funcionamiento del remonte, pero no cubre accidentes en pista.",
        recommended: [
          "Seguro específico de accidentes de esquí para las pistas (ofrecido por RACE).",
          "Seguro de anulación (12 € por persona, contratable al reservar o en las 48 h siguientes).",
        ],
      },
      before_travel: [
        "Videollamada informativa con el coordinador del viaje unos días antes de la salida.",
        "Circular con todos los detalles del viaje enviada por email.",
        "Alergias, dietas especiales o cualquier requisito particular: indícalos al reservar en el campo de observaciones. Tanto el hotel como los restaurantes en pista los tienen previstos.",
      ],
    },
    booking_info: {
      deposit: "Señal de 100 € por persona al confirmar la reserva.",
      payment:
        "El resto se abona en cuotas — transferencia o efectivo en oficina — antes de la fecha límite que verás en tu panel privado (aprox. 2 semanas antes del viaje).",
      confirmation:
        "Recibes la confirmación por email y puedes consultarla en tu área privada. Antes del viaje mantenemos una videollamada con el coordinador y te enviamos la circular con todos los detalles.",
      discounts: [
        "5 % de descuento a clientes que ya han viajado con Club Amistad (aplicable sobre el paquete base, no sobre los suplementos).",
        "50 % de descuento en clases para el 3er niño y siguientes cuando inscribes 3 o más niños (sobre las clases de menor valor).",
      ],
      cancellation: [
        { when: "Desde la reserva hasta 31 días antes", amount: "15 € por persona" },
        { when: "Entre 30 y 22 días antes", amount: "100 € por persona" },
        { when: "Entre 21 y 15 días antes", amount: "50 % del paquete base" },
        { when: "Entre 14 y 8 días antes", amount: "75 % de la reserva total" },
        { when: "En los últimos 7 días", amount: "100 %" },
      ],
      guarantee:
        "Garantía poca nieve: cancelación sin penalización si la estación no puede abrir un mínimo de 15 km esquiables el primer día (según el parte diario de la estación).",
    },
    faqs: [
      {
        q: "¿Semana Santa en Cerler suele tener buena nieve?",
        a: "Sí. Es de los mejores momentos para esquiar en Cerler: al ambiente primaveral se suma una base sólida de nieve tras toda la temporada, además de los 389 cañones y 40 km innivados como refuerzo. Semana Santa suele ser esquí con sol y buena temperatura.",
      },
      {
        q: "Es nuestra primera vez esquiando con los niños, ¿es un buen sitio para empezar?",
        a: "Cerler es una de las mejores estaciones familiares del Pirineo. La zona debutantes es amplia y muy segura, con pistas que bajan hasta el mismo pueblo. El Monte Alba, a 200 m del telesilla, es el hotel más cómodo para no tener que cargar con material.",
      },
      {
        q: "¿Qué hacen los niños mientras yo esquío?",
        a: "Si contratáis las clases todo el día (opcional), pasan la jornada con nuestros monitores: aprenden, esquían y comen supervisados de 10 a 16h. Por las tardes hay actividades organizadas de 18:00 a 20:00 sin coste. Si preferís no meter a los peques en clases, la piscina del hotel y el programa de animación son un plan perfecto.",
      },
      {
        q: "Los niños de 0 a 1 años, ¿vienen gratis de verdad?",
        a: "Totalmente. Los bebés en cuna no pagan alojamiento ni pensión. En este viaje hay una tarifa reducida específica para 2-3 años (213 €) que incluye alojamiento y media pensión, pero no forfait.",
      },
      {
        q: "¿Puedo pagar en cómodos plazos?",
        a: "Sí. Se abona una señal de 100 € por persona para confirmar la plaza y el resto en cuotas hasta unas dos semanas antes del viaje.",
      },
      {
        q: "¿Y si no hay nieve?",
        a: "Contamos con la garantía poca nieve: si Cerler no puede abrir un mínimo de 15 km esquiables el primer día, cancelas sin penalización. La estación cuenta con 389 cañones y 40 km innivados — nieve asegurada.",
      },
    ],
    seo_title:
      "Viaje a la nieve en Cerler · Semana Santa 2027 (19-23 mar) | Club Amistad",
    seo_description:
      "Semana Santa 2027 en Cerler. Hotel Monte Alba a pie de pista, forfait 4 días, monitores propios y actividades para niños. Alojamiento, media pensión y forfait incluidos.",
  },
  {
    slug: "masella-semana-santa",
    extended: true,
    external_id: 266,
    booking_url: "https://www.clubamistad.com/viajes-esqui/presupuesto/266",
    pdf_url: "/dossiers/masella-semana-santa.pdf",
    name: "Masella, Semana Santa",
    short_name: "Masella",
    season: "Semana Santa",
    dates: "Del miércoles 24 al domingo 28 de marzo de 2027",
    dates_short: "24 – 28 mar 2027",
    duration: "5 días / 4 noches",
    ski_days: 4,
    regimen: "Media pensión — desayuno y cena buffet",
    room_distribution: "Habitaciones de 2 a 6 personas",
    price_from: 298,
    price_label: "Desde 298 €/persona",
    family_basis: "2 adultos + 2 niños",
    hero_image: "/trips/masella-semana-santa/hero.jpg",
    image: "/trips/masella-semana-santa/01.jpg",
    gallery: [
      "/trips/masella-semana-santa/01.jpg",
      "/trips/masella-semana-santa/02.jpg",
      "/trips/masella-semana-santa/03.jpg",
      "/trips/masella-semana-santa/04.jpg",
      "/trips/masella-semana-santa/05.jpg",
      "/trips/masella-semana-santa/06.jpg",
    ],
    hotel: {
      name: "Alp Hotel Masella 3★",
      subtitle: "A 300 m de la base · piscina climatizada · cine y sala de juegos",
      address: "Avenida de Josep Maria Bosch Aymerich, s/n · 17538 Alp · Girona",
      phone: "972 144 201",
      highlights: [
        "Los niños bajan a desayunar y salen a la pista literalmente en la puerta del hotel.",
        "Comidas buffet — cada uno elige, sin dramas ni negociaciones a la hora del plato.",
        "Piscina interior climatizada, gimnasio, cine, sala de juegos y hasta discoteca para la sobremesa.",
        "Habitaciones familiares para 2 a 6 personas, pensadas para no ir apretados con los pequeños.",
      ],
      extra_info: {
        description:
          "Este hotel está situado frente a las mismas pistas de Masella, a escasos metros de la zona de debutantes y remontes. Ideal para familias, tanto por la cercanía a pistas como por las actividades que se organizan tarde y noche para todas las edades. Todas las comidas son estilo buffet y cuenta con piscina interior climatizada, gimnasio y zonas de ocio (cine, sala de juegos y discoteca). La mayor virtud de este hotel es sin duda su situación, en la misma base de la estación. Apenas 300 metros separan su puerta principal de la base de la estación, su zona de debutantes y los remontes que dan acceso a las cotas altas. Las habitaciones son sencillas y funcionales. Las habitaciones estándar cuentan con dos camas individuales y un espacio donde se incorporan las supletorias, ya sea una con cama inferior o dos, con la litera correspondiente. Para familias de 5 o más miembros el hotel cuenta con un número limitado de habitaciones familiares con dos habitáculos y un único cuarto de baño.",
        services: ["Animación", "Piscina", "Discoteca", "Comidas tipo buffet", "Pie de pista"],
        amenities: [
          "Piscina interior climatizada",
          "Gimnasio",
          "Cine",
          "Sala de juegos",
          "Discoteca",
          "Bar con vistas",
          "Futbolines y billar",
        ],
        map_query: "Alp Hotel Masella, Avenida Josep Maria Bosch Aymerich, 17538 Alp, Girona",
      },
    },
    resort: {
      name: "Masella",
      subtitle: "La joya escondida del esquí español",
      highlights: [
        "Pistas largas entre pinos, con un ambiente que en España no encontrarás en otra estación.",
        "El mayor desnivel esquiable de España — sensación de estar en los Alpes sin salir del país.",
        "Amplia zona debutantes al lado del hotel, ideal para primer contacto con la nieve.",
        "El mayor dominio de esquí nocturno de la península, por si os apetece una bajada distinta.",
      ],
      stats: {
        skiable_km: 74,
        slopes_total: 65,
        slopes_breakdown: { green: 9, blue: 24, red: 22, black: 10 },
        snowmaking_km: 53,
        altitude: "1.600 – 2.535 m",
      },
      extra_info: {
        description:
          "La estación de Masella es una de las joyas desconocidas del esquí en España. Sorprende al visitante por la belleza de sus largas pistas entre pinos, sin igual en todo el país. Ofrece además el mayor desnivel de España y el mayor dominio de esquí nocturno de la península.",
        connections:
          "Conectada con La Molina formando Alp2500, el segundo dominio esquiable unido más grande de España con 145 km de pistas combinadas.",
        note: "Ampliación de forfait a La Molina disponible como suplemento opcional (35 € adulto / 8 € niño 4-6 años).",
        map_query: "Masella, 17538 Alp, Girona",
      },
    },
    intro:
      "Semana Santa en el Pirineo catalán con Masella entre pinos, sol de primavera y todo el confort del Alp Hotel a pie de pista. Cinco días para cerrar la temporada esquiando en familia con la tranquilidad de tenerlo todo organizado — hotel, forfait, monitores y actividades para los peques.",
    pain_hook:
      "Semana Santa suele ser cambio de hora, exámenes cerca y necesidad de recargar pilas antes del último trimestre. Aquí llegas con todo listo: los niños con sus clases y actividades, tú esquiando por las larguísimas pistas entre pinos de Masella y por la tarde piscina y cine en el mismo hotel.",
    prices: [
      { label: "Adulto", amount: 498 },
      { label: "Joven 13–24 años", amount: 478 },
      { label: "Niño 7–12 años", amount: 398, note: "En habitación con dos adultos" },
      { label: "Niño 4–6 años", amount: 298, note: "En habitación con dos adultos" },
      { label: "Niño 0–3 años", amount: 0, note: "En habitación con dos adultos, gratuito", free: true },
    ],
    includes: [
      "Alojamiento 4 noches a pie de pista en el Alp Hotel Masella 3★",
      "Media pensión (desayuno y cena buffet)",
      "Forfait Masella 4 días (excepto niños 0-3 años)",
      "Actividades por las tardes para los niños, supervisadas",
      "Guía Club Amistad y personal de apoyo en destino",
      "Atención personalizada antes, durante y después del viaje",
    ],
    supplements: [
      { label: "Clases de esquí adulto (2 h/día)", amount: 118 },
      { label: "Clases de esquí niños 6–14 años (todo el día)", amount: 198 },
      { label: "Clases de esquí niños 4–5 años (todo el día)", amount: 378 },
      { label: "Alquiler de equipo completo adulto", amount: 93 },
      { label: "Alquiler de equipo completo niño 7–17 años", amount: 80 },
      { label: "Alquiler de equipo completo niño 0–6 años", amount: 58 },
      { label: "Comida del mediodía — niños con clases", amount: 49 },
      { label: "Seguro de anulación", amount: 12 },
    ],
    notes: [
      "El precio no incluye tasas de estancia (aprox. 4 €/adulto).",
      "El precio no incluye seguros — recomendamos contratar seguro de accidentes específico de esquí.",
      "Viaje organizado y comercializado por Viajes Amitour · CIC.MA 841.",
    ],
    program: {
      classes: {
        intro:
          "Todas las clases están impartidas por monitores propios del Club Amistad, no por escuelas externas. Los grupos son reducidos y los niños comen con sus profesores en pista.",
        min_age: "4 años cumplidos (estricto — no se admite “casi 4 años”)",
        schedule: "Jornada completa de 10:00 a 16:00",
        groups: [
          { ages: "4–5 años", label: "Esquí Mimo", group_size: "Grupos de 3 a 5 alumnos" },
          { ages: "6–14 años", label: "Grupos por nivel", group_size: "Máximo 10 alumnos por grupo" },
        ],
        meal_note:
          "Los niños que asisten a clases comen con sus profesores en pista de 10:00 a 16:00. La comida del mediodía es obligatoria si van a clases y se contrata como suplemento (49 €).",
      },
      evening_activities: {
        schedule: "De 18:00 a 20:00, todos los días",
        description:
          "Juegos y actividades supervisadas por nuestros monitores dentro del hotel. Abiertas a todos los niños tengan o no clases, y sin coste adicional. La participación es voluntaria — la tarde es vuestra para hacer lo que os apetezca.",
      },
      insurance: {
        included:
          "El forfait incluye un seguro obligatorio que cubre el correcto funcionamiento del remonte, pero no cubre accidentes en pista.",
        recommended: [
          "Seguro específico de accidentes de esquí para las pistas (ofrecido por RACE).",
          "Seguro de anulación (12 € por persona, contratable al reservar o en las 48 h siguientes).",
        ],
      },
      before_travel: [
        "Videollamada informativa con el coordinador del viaje unos días antes de la salida.",
        "Circular con todos los detalles del viaje enviada por email.",
        "Alergias, dietas especiales o cualquier requisito particular: indícalos al reservar en el campo de observaciones. Tanto el hotel como los restaurantes en pista los tienen previstos.",
      ],
    },
    booking_info: {
      deposit: "Señal de 100 € por persona al confirmar la reserva.",
      payment:
        "El resto se abona en cuotas — transferencia o efectivo en oficina — antes de la fecha límite que verás en tu panel privado (aprox. 2 semanas antes del viaje).",
      confirmation:
        "Recibes la confirmación por email y puedes consultarla en tu área privada. Antes del viaje mantenemos una videollamada con el coordinador y te enviamos la circular con todos los detalles.",
      discounts: [
        "5 % de descuento a clientes que ya han viajado con Club Amistad (aplicable sobre el paquete base, no sobre los suplementos).",
        "50 % de descuento en clases para el 3er niño y siguientes cuando inscribes 3 o más niños (sobre las clases de menor valor).",
      ],
      cancellation: [
        { when: "Desde la reserva hasta 31 días antes", amount: "15 € por persona" },
        { when: "Entre 30 y 22 días antes", amount: "100 € por persona" },
        { when: "Entre 21 y 15 días antes", amount: "50 % del paquete base" },
        { when: "Entre 14 y 8 días antes", amount: "75 % de la reserva total" },
        { when: "En los últimos 7 días", amount: "100 %" },
      ],
      guarantee:
        "Garantía poca nieve: cancelación sin penalización si la estación no puede abrir un mínimo de 15 km esquiables el primer día (según el parte diario de la estación).",
    },
    faqs: [
      {
        q: "¿Cómo suele estar la nieve en Masella a finales de marzo?",
        a: "Semana Santa en Masella suele combinar buena base de nieve tras toda la temporada con temperaturas más agradables y sol. Además, Masella cuenta con 53 km innivados como refuerzo, así que la calidad de nieve suele estar asegurada.",
      },
      {
        q: "¿Puedo ampliar el forfait a La Molina?",
        a: "Sí. Masella está conectada con La Molina formando el dominio Alp2500 (145 km). La ampliación se contrata como suplemento opcional (35 € adulto / 8 € niño 4-6 años).",
      },
      {
        q: "¿Qué hacen los niños mientras yo esquío?",
        a: "Si contratáis las clases todo el día (opcional), pasan la jornada con nuestros monitores: aprenden, esquían y comen supervisados de 10 a 16h. Por las tardes hay actividades organizadas de 18:00 a 20:00 sin coste. El hotel tiene además piscina climatizada, cine, sala de juegos y hasta discoteca.",
      },
      {
        q: "¿Cómo funciona la tarifa para jóvenes de 13-24 años?",
        a: "Los jóvenes de 13 a 24 años tienen una tarifa reducida específica (478 €) que aplica en habitación compartida con adultos. Es una tarifa pensada para adolescentes y jóvenes universitarios que viajan con la familia.",
      },
      {
        q: "¿Puedo pagar en cómodos plazos?",
        a: "Sí. Se abona una señal de 100 € por persona para confirmar la plaza y el resto en cuotas hasta unas dos semanas antes del viaje.",
      },
      {
        q: "¿Y si no hay nieve?",
        a: "Contamos con la garantía poca nieve: si Masella no puede abrir un mínimo de 15 km esquiables el primer día, cancelas sin penalización. Con 53 km innivados y su altitud, es una de las estaciones más fiables.",
      },
    ],
    seo_title:
      "Viaje a la nieve en Masella · Semana Santa 2027 (24-28 mar) | Club Amistad",
    seo_description:
      "Semana Santa 2027 en Masella con Alp Hotel a pie de pista, forfait 4 días y monitores propios. Tarifa reducida jóvenes 13-24 años. Desde 298 € por niño 4–6 años; adulto 498 €.",
  },
  {
    slug: "masella-esquiada-familiar",
    extended: true,
    external_id: 297,
    booking_url: "https://www.clubamistad.com/viajes-esqui/presupuesto/297",
    pdf_url: "/dossiers/masella-esquiada-familiar.pdf",
    name: "Masella–La Molina, Esquiada Familiar",
    short_name: "Masella",
    season: "Esquiada Familiar",
    dates: "Del viernes 29 de enero al martes 2 de febrero de 2027",
    dates_short: "29 ene – 2 feb 2027",
    duration: "5 días / 4 noches",
    ski_days: 4,
    regimen: "Pensión completa — desayuno, comida y cena buffet",
    room_distribution: "Habitaciones de 2 a 6 personas",
    price_from: 328,
    price_label: "Desde 328 €/persona",
    family_basis: "2 adultos + 2 niños",
    hero_image: "/trips/masella-esquiada-familiar/hero.jpg",
    image: "/trips/masella-esquiada-familiar/01.jpg",
    gallery: [
      "/trips/masella-esquiada-familiar/01.jpg",
      "/trips/masella-esquiada-familiar/02.jpg",
      "/trips/masella-esquiada-familiar/03.jpg",
      "/trips/masella-esquiada-familiar/04.jpg",
      "/trips/masella-esquiada-familiar/05.jpg",
    ],
    hotel: {
      name: "Alp Hotel Masella 3★",
      subtitle: "A 300 m de la base · piscina climatizada · cine y sala de juegos",
      address: "Avenida de Josep Maria Bosch Aymerich, s/n · 17538 Alp · Girona",
      phone: "972 144 201",
      highlights: [
        "A pie de pista: de la puerta del hotel a la zona de debutantes hay 300 metros.",
        "Pensión completa con las tres comidas en buffet — también la del mediodía.",
        "Piscina interior climatizada, gimnasio, cine, sala de juegos y discoteca para la tarde.",
        "Habitaciones familiares de 2 a 6 personas para no ir apretados con los peques.",
      ],
      extra_info: {
        description:
          "Este hotel está situado frente a las mismas pistas de Masella, a escasos metros de la zona de debutantes y remontes. Ideal para familias, tanto por la cercanía a pistas como por las actividades que se organizan tarde y noche para todas las edades. Todas las comidas son estilo buffet y cuenta con piscina interior climatizada, gimnasio y zonas de ocio (cine, sala de juegos y discoteca). Las habitaciones son sencillas y funcionales. Las habitaciones estándar cuentan con dos camas individuales y un espacio donde se incorporan las supletorias. Para familias de 5 o más miembros el hotel cuenta con un número limitado de habitaciones familiares con dos habitáculos y un único cuarto de baño.",
        services: ["Animación", "Piscina", "Discoteca", "Comidas tipo buffet", "Pie de pista"],
        amenities: [
          "Piscina interior climatizada",
          "Gimnasio",
          "Cine",
          "Sala de juegos",
          "Discoteca",
          "Bar con vistas",
          "Futbolines y billar",
        ],
        map_query: "Alp Hotel Masella, Avenida Josep Maria Bosch Aymerich, 17538 Alp, Girona",
      },
    },
    resort: {
      name: "Masella – La Molina (Alp2500)",
      subtitle: "El segundo dominio conectado más grande de España",
      highlights: [
        "145 km esquiables entre Masella y La Molina, unidos por pistas en el dominio Alp2500.",
        "Zona de debutantes justo enfrente del alojamiento, a pie de pista.",
        "Largas pistas azules entre pinos y rojas y negras a 2.500 metros.",
        "Esquí nocturno incluido el sábado: el mayor dominio nocturno de la península.",
      ],
      stats: {
        skiable_km: 74,
        slopes_total: 65,
        slopes_breakdown: { green: 9, blue: 24, red: 22, black: 10 },
        snowmaking_km: 53,
        altitude: "1.600 – 2.535 m",
      },
      extra_info: {
        description:
          "La unión de Masella y La Molina en un único dominio le convierte, con 145 km de pistas esquiables, en el segundo dominio conectado por pistas más grande de España. El sector de Masella cuenta con modernas instalaciones con 6 remontes desembragables y un completo parque de nieve, además del mayor desnivel esquiable del país.",
        connections:
          "Conectada con La Molina formando Alp2500, el segundo dominio esquiable unido más grande de España con 145 km de pistas combinadas.",
        note: "El forfait incluido es de Masella. La ampliación a todo el dominio La Molina se contrata como suplemento opcional (35 €).",
        map_query: "Masella, 17538 Alp, Girona",
      },
    },
    intro:
      "La Esquiada Familiar es el viaje más completo de la temporada: cuatro días de esquí en Masella con pensión completa, esquí nocturno el sábado y el Alp Hotel a pie de pista. Un puente de finales de enero, con la mejor nieve del invierno, pensado para que la familia entera esquíe junta sin preocuparse de nada.",
    pain_hook:
      "Finales de enero es cuando mejor está la nieve y cuando menos gente hay en pista. Aquí lo tienes todo resuelto: las tres comidas incluidas, los niños con monitores propios si contratáis clases, actividades por la tarde y una bajada de esquí nocturno el sábado que los peques recordarán toda la vida.",
    prices: [
      { label: "Adulto", amount: 528 },
      { label: "Joven 13–17 años", amount: 478 },
      { label: "Niño 7–12 años", amount: 398, note: "En habitación con dos adultos" },
      { label: "Niño 4–6 años", amount: 328, note: "En habitación con dos adultos" },
      { label: "Niño 0–3 años", amount: 0, note: "En habitación con dos adultos, gratuito", free: true },
    ],
    includes: [
      "Alojamiento 4 noches a pie de pista en el Alp Hotel Masella 3★",
      "Pensión completa (desayuno, comida y cena buffet)",
      "Forfait Masella 4 días (excepto niños 0-3 años)",
      "Esquí nocturno el sábado",
      "Actividades por las tardes para los niños, supervisadas",
      "Guía Club Amistad y personal de apoyo en destino (coordinador 24 h)",
    ],
    supplements: [
      { label: "Clases de esquí adulto (2 h/día)", amount: 118 },
      { label: "Clases de esquí niños 6–14 años (todo el día)", amount: 148 },
      { label: "Clases de esquí niños 4–5 años (todo el día)", amount: 248 },
      { label: "Alquiler de equipo completo adulto", amount: 93 },
      { label: "Alquiler de equipo completo niño 7–17 años", amount: 80 },
      { label: "Alquiler de equipo completo niño 0–6 años", amount: 58 },
      { label: "Ampliación de forfait a La Molina (Alp2500)", amount: 35 },
      { label: "Seguro de asistencia", amount: 23 },
      { label: "Seguro de anulación", amount: 12 },
    ],
    notes: [
      "El precio no incluye tasas de estancia (aprox. 4 €/adulto).",
      "El precio no incluye seguros — recomendamos contratar seguro de accidentes específico de esquí.",
      "Viaje organizado y comercializado por Viajes Amitour · CIC.MA 841.",
    ],
    program: {
      classes: {
        intro:
          "Todas las clases están impartidas por monitores propios del Club Amistad, no por escuelas externas. Los grupos son reducidos y los niños comen con sus profesores en pista — la comida ya está incluida en el precio del viaje.",
        min_age: "4 años cumplidos (estricto — no se admite “casi 4 años”)",
        schedule: "Jornada completa de 10:00 a 16:00",
        groups: [
          { ages: "4–5 años", label: "Esquí Mimo", group_size: "Grupos de 3 a 5 alumnos" },
          { ages: "6–14 años", label: "Grupos por nivel", group_size: "Máximo 10 alumnos por grupo" },
        ],
        meal_note:
          "Los niños que asisten a clases comen con sus profesores en pista de 10:00 a 16:00. Al ser un viaje en pensión completa, esa comida ya está incluida en el precio.",
      },
      evening_activities: {
        schedule: "De 18:00 a 20:00, todos los días",
        description:
          "Juegos y actividades supervisadas por nuestros monitores dentro del hotel. Abiertas a todos los niños tengan o no clases, y sin coste adicional. La participación es voluntaria — la tarde es vuestra para hacer lo que os apetezca.",
      },
      insurance: {
        included:
          "El forfait incluye un seguro obligatorio que cubre el correcto funcionamiento del remonte, pero no cubre accidentes en pista.",
        recommended: [
          "Seguro específico de accidentes de esquí para las pistas (ofrecido por RACE).",
          "Seguro de anulación (12 € por persona, contratable al reservar o en las 48 h siguientes).",
        ],
      },
      before_travel: [
        "Videollamada informativa con el coordinador del viaje unos días antes de la salida.",
        "Circular con todos los detalles del viaje enviada por email.",
        "Alergias, dietas especiales o cualquier requisito particular: indícalos al reservar en el campo de observaciones. Tanto el hotel como los restaurantes en pista los tienen previstos.",
      ],
    },
    booking_info: {
      deposit: "Señal de 100 € por persona al confirmar la reserva.",
      payment:
        "El resto se abona en cuotas — transferencia o efectivo en oficina — antes de la fecha límite que verás en tu panel privado (aprox. 2 semanas antes del viaje).",
      confirmation:
        "Recibes la confirmación por email y puedes consultarla en tu área privada. Antes del viaje mantenemos una videollamada con el coordinador y te enviamos la circular con todos los detalles.",
      discounts: [
        "5 % de descuento a clientes que ya han viajado con Club Amistad (aplicable sobre el paquete base, no sobre los suplementos).",
        "50 % de descuento en clases para el 3er niño y siguientes cuando inscribes 3 o más niños (sobre las clases de menor valor).",
      ],
      cancellation: [
        { when: "Desde la reserva hasta 31 días antes", amount: "15 € por persona" },
        { when: "Entre 30 y 22 días antes", amount: "100 € por persona" },
        { when: "Entre 21 y 15 días antes", amount: "50 % del paquete base" },
        { when: "Entre 14 y 8 días antes", amount: "75 % de la reserva total" },
        { when: "En los últimos 7 días", amount: "100 %" },
      ],
      guarantee:
        "Garantía poca nieve: cancelación sin penalización si la estación no puede abrir un mínimo de 15 km esquiables el primer día (según el parte diario de la estación).",
    },
    faqs: [
      {
        q: "¿Qué diferencia a la Esquiada Familiar de los otros viajes a Masella?",
        a: "Es el viaje más completo del calendario: va en pensión completa (las tres comidas incluidas, también la del mediodía en pista) e incluye una sesión de esquí nocturno el sábado. Además cae a finales de enero, cuando la nieve suele estar en su mejor momento y hay menos gente en pista.",
      },
      {
        q: "¿La comida del mediodía está incluida?",
        a: "Sí. Este viaje es en pensión completa, así que desayuno, comida y cena están incluidos en el precio. Es una diferencia importante respecto a otras salidas, donde la comida en pista se contrata aparte.",
      },
      {
        q: "¿Qué es el esquí nocturno del sábado?",
        a: "Masella tiene el mayor dominio de esquí nocturno de la península. El sábado por la noche se abren pistas iluminadas y la sesión está incluida en el precio del viaje: una bajada distinta que a los niños les encanta.",
      },
      {
        q: "¿Puedo esquiar también en La Molina?",
        a: "El forfait incluido es de Masella. Si queréis acceder a todo el dominio Alp2500 (145 km entre Masella y La Molina), se puede ampliar como suplemento opcional por 35 €.",
      },
      {
        q: "¿Desde qué edad pueden ir los niños a clases?",
        a: "Desde los 4 años cumplidos (sin excepciones). Los de 4 y 5 años van al curso Esquí Mimo en grupos de 3 a 5 alumnos; de 6 a 14 años, jornada completa con un máximo de 10 alumnos por grupo. Los menores de 4 años pueden venir al viaje, pero no a clases.",
      },
      {
        q: "¿Y si no hay nieve?",
        a: "Contamos con la garantía poca nieve: si Masella no puede abrir un mínimo de 15 km esquiables el primer día, cancelas sin penalización. Con 53 km innivados y su altitud, es una de las estaciones más fiables de España.",
      },
    ],
    seo_title:
      "Viaje a la nieve en Masella–La Molina · Esquiada Familiar 2027 (29 ene-2 feb) | Club Amistad",
    seo_description:
      "Esquiada Familiar 2027 en Masella: 4 días de esquí, Alp Hotel a pie de pista, pensión completa y esquí nocturno el sábado. Desde 328 € por niño 4–6 años; adulto 528 €.",
  },
];

export const getTripBySlug = (slug) => TRIPS.find((t) => t.slug === slug);

// El "precio desde" de cada viaje corresponde SIEMPRE a la categoría infantil de pago
// más económica, no a un adulto ni al total de la familia. Esta función devuelve el
// importe junto a la categoría a la que pertenece para poder mostrarlo sin ambigüedad.
export const getPriceFrom = (trip) => {
  const paid = (trip.prices || []).filter((p) => !p.free && p.amount > 0);
  const cheapest = paid.reduce(
    (min, p) => (min === null || p.amount < min.amount ? p : min),
    null
  );
  const adult = (trip.prices || []).find((p) => /adulto/i.test(p.label));
  return {
    amount: cheapest ? cheapest.amount : trip.price_from,
    label: cheapest ? cheapest.label : null,
    adult: adult ? adult.amount : null,
  };
};
